/* eslint-disable */
module.exports.data = {
  xinshili: {
    youxi: {
      vRank: {
        proto: {
          tJump: {
            lPid: 0,
            lTid: 0,
            lSid: 0,
            iGameId: 0,
            lYYId: 0,
            iRoomId: 0,
          },
          tPresenter: {
            lPid: 0,
            sNickName: '',
            sLogoUrl: '',
            sPortait: '',
            sBriefText: '',
          },
          iRank: 0,
          lScore: 0,
        },
        value: [
          {
            tJump: {
              lPid: 2230044809,
              lTid: 0,
              lSid: 0,
              iGameId: 0,
              lYYId: 2230034393,
              iRoomId: 331272,
            },
            tPresenter: {
              lPid: 2230044809,
              sNickName: 'Dae-小抠脚',
              sLogoUrl: 'https://huyaimg.msstatic.com/avatar/1012/ec/62d281aef2150311ed11e5d8c2f79d_180_135.jpg?1536230188',
              sPortait: 'https://v-cms-img.huya.com/huya/201912ND/photov1/122.png',
              sBriefText: '吃鸡狙神，国服双人榜一大神，新晋吃鸡男神',
            },
            iRank: 1,
            lScore: 5404354,
          },
          {
            tJump: {
              lPid: 2302212908,
              lTid: 0,
              lSid: 0,
              iGameId: 0,
              lYYId: 2302141446,
              iRoomId: 903571,
            },
            tPresenter: {
              lPid: 2302212908,
              sNickName: 'EL-小燕子',
              sLogoUrl: 'https://huyaimg.msstatic.com/avatar/1075/63/d1a7fbd4b0f69fbcd0627d834b693f_180_135.jpg?1564484658',
              sPortait: 'http://livewebbs2.msstatic.com/201912guying.png',
              sBriefText: '主播简介....',
            },
            iRank: 2,
            lScore: 3117424,
          },
          {
            tJump: {
              lPid: 59250014,
              lTid: 0,
              lSid: 0,
              iGameId: 0,
              lYYId: 9016999,
              iRoomId: 801891,
            },
            tPresenter: {
              lPid: 59250014,
              sNickName: 'LK-王小宝',
              sLogoUrl: 'https://huyaimg.msstatic.com/avatar/1099/18/98d9bd27b864d7f438efd18fc257eb_180_135.jpg?1545491069',
              sPortait: 'http://livewebbs2.msstatic.com/201912guying.png',
              sBriefText: '主播简介....',
            },
            iRank: 3,
            lScore: 2581722,
          },
          {
            tJump: {
              lPid: 2321912140,
              lTid: 0,
              lSid: 0,
              iGameId: 0,
              lYYId: 2323853084,
              iRoomId: 17200828,
            },
            tPresenter: {
              lPid: 2321912140,
              sNickName: '星点丶可可鸭',
              sLogoUrl: 'https://huyaimg.msstatic.com/avatar/1046/96/fd35a3dbcf9819ea93d19530dc9f41_180_135.jpg?1576647828',
              sPortait: 'http://livewebbs2.msstatic.com/201912guying.png',
              sBriefText: '主播简介....',
            },
            iRank: 4,
            lScore: 2271808,
          },
          {
            tJump: {
              lPid: 2190177152,
              lTid: 0,
              lSid: 0,
              iGameId: 0,
              lYYId: 2190326523,
              iRoomId: 759569,
            },
            tPresenter: {
              lPid: 2190177152,
              sNickName: '流年-乔妹',
              sLogoUrl: 'https://huyaimg.msstatic.com/avatar/1091/4b/95ff7ce3bdc7f3f603ab8c92f36e17_180_135.jpg?1576486076',
              sPortait: 'http://livewebbs2.msstatic.com/201912guying.png',
              sBriefText: '主播简介....',
            },
            iRank: 5,
            lScore: 1295232,
          },
          {
            tJump: {
              lPid: 1576969520,
              lTid: 0,
              lSid: 0,
              iGameId: 0,
              lYYId: 1780786504,
              iRoomId: 525925,
            },
            tPresenter: {
              lPid: 1576969520,
              sNickName: '961丶仙女瑞',
              sLogoUrl: 'https://huyaimg.msstatic.com/avatar/1045/15/df9edcf30df189f50fb1013a5e4810_180_135.jpg?1575861051',
              sPortait: 'http://livewebbs2.msstatic.com/201912guying.png',
              sBriefText: '主播简介....',
            },
            iRank: 6,
            lScore: 1282746,
          },
          {
            tJump: {
              lPid: 79003544,
              lTid: 56727451,
              lSid: 56727451,
              iGameId: 135,
              lYYId: 31064683,
              iRoomId: 18929718,
            },
            tPresenter: {
              lPid: 79003544,
              sNickName: 'YM-曼纱',
              sLogoUrl: 'https://huyaimg.msstatic.com/avatar/1007/a8/15a3fd153eb81c94469b0af874e35a_180_135.jpg?1576601974',
              sPortait: 'http://livewebbs2.msstatic.com/201912guying.png',
              sBriefText: '主播简介....',
            },
            iRank: 7,
            lScore: 1110639,
          },
          {
            tJump: {
              lPid: 2367358476,
              lTid: 0,
              lSid: 0,
              iGameId: 0,
              lYYId: 2369636321,
              iRoomId: 235604,
            },
            tPresenter: {
              lPid: 2367358476,
              sNickName: '荼蘼tumi',
              sLogoUrl: 'https://huyaimg.msstatic.com/avatar/1058/56/08bee9ee9a465b0c6c5a02def9099d_180_135.jpg?1552497251',
              sPortait: 'http://livewebbs2.msstatic.com/201912guying.png',
              sBriefText: '主播简介....',
            },
            iRank: 8,
            lScore: 965942,
          },
          {
            tJump: {
              lPid: 1199518915448,
              lTid: 1199518915448,
              lSid: 1199518915448,
              iGameId: 2336,
              lYYId: 35184393514474,
              iRoomId: 19380807,
            },
            tPresenter: {
              lPid: 1199518915448,
              sNickName: '白羊睡不醒',
              sLogoUrl: 'https://huyaimg.msstatic.com/avatar/1023/21/35aa7efa0cd58f4f77be7867c6c16b_180_135.jpg?1576343449',
              sPortait: 'http://livewebbs2.msstatic.com/201912guying.png',
              sBriefText: '主播简介....',
            },
            iRank: 9,
            lScore: 887143,
          },
          {
            tJump: {
              lPid: 2399113093,
              lTid: 1447237365,
              lSid: 1447237365,
              iGameId: 2336,
              lYYId: 2401008731,
              iRoomId: 597039,
            },
            tPresenter: {
              lPid: 2399113093,
              sNickName: 'Dae-乐瑾',
              sLogoUrl: 'https://huyaimg.msstatic.com/avatar/1090/54/5afe2f3625a06f8ecf7a0cbf819eb2_180_135.jpg?1563553950',
              sPortait: 'http://livewebbs2.msstatic.com/201912guying.png',
              sBriefText: '主播简介....',
            },
            iRank: 10,
            lScore: 804156,
          },
          {
            tJump: {
              lPid: 2217308710,
              lTid: 0,
              lSid: 0,
              iGameId: 0,
              lYYId: 2217375414,
              iRoomId: 651632,
            },
            tPresenter: {
              lPid: 2217308710,
              sNickName: '巅峰-蓝总',
              sLogoUrl: 'https://huyaimg.msstatic.com/avatar/1065/74/a67dd84e0644fff3725f052a9109c9_180_135.jpg?1560492842',
              sPortait: 'http://livewebbs2.msstatic.com/201912guying.png',
              sBriefText: '主播简介....',
            },
            iRank: 11,
            lScore: 788949,
          },
          {
            tJump: {
              lPid: 1199518309659,
              lTid: 0,
              lSid: 0,
              iGameId: 0,
              lYYId: 35184390554788,
              iRoomId: 19279929,
            },
            tPresenter: {
              lPid: 1199518309659,
              sNickName: '虎牙-非凡枫心',
              sLogoUrl: 'https://huyaimg.msstatic.com/avatar/1095/d3/7ed23222cb5db926a93e35010c0608_180_135.jpg?1571190367',
              sPortait: 'http://livewebbs2.msstatic.com/201912guying.png',
              sBriefText: '主播简介....',
            },
            iRank: 12,
            lScore: 755238,
          },
          {
            tJump: {
              lPid: 1851875811,
              lTid: 0,
              lSid: 0,
              iGameId: 0,
              lYYId: 2104540174,
              iRoomId: 19394311,
            },
            tPresenter: {
              lPid: 1851875811,
              sNickName: '流年-瓜子【加油】',
              sLogoUrl: 'https://huyaimg.msstatic.com/avatar/1044/83/87b70895508dff9ff2ccde9efc95c4_180_135.jpg?1564742892',
              sPortait: 'http://livewebbs2.msstatic.com/201912guying.png',
              sBriefText: '主播简介....',
            },
            iRank: 13,
            lScore: 745203,
          },
          {
            tJump: {
              lPid: 1865947642,
              lTid: 0,
              lSid: 0,
              iGameId: 0,
              lYYId: 2118597180,
              iRoomId: 18968678,
            },
            tPresenter: {
              lPid: 1865947642,
              sNickName: '太阳',
              sLogoUrl: 'https://huyaimg.msstatic.com/avatar/1074/61/0a21eecfff8f29f478519dbcc0104e_180_135.jpg?1567182621',
              sPortait: 'http://livewebbs2.msstatic.com/201912guying.png',
              sBriefText: '主播简介....',
            },
            iRank: 14,
            lScore: 742087,
          },
          {
            tJump: {
              lPid: 1628701222,
              lTid: 0,
              lSid: 0,
              iGameId: 0,
              lYYId: 1846705957,
              iRoomId: 18996058,
            },
            tPresenter: {
              lPid: 1628701222,
              sNickName: '巅峰-情义',
              sLogoUrl: 'https://huyaimg.msstatic.com/avatar/1067/50/b2c7f550e4abb47138a6af2769bf76_180_135.jpg?1574078513',
              sPortait: 'http://livewebbs2.msstatic.com/201912guying.png',
              sBriefText: '主播简介....',
            },
            iRank: 15,
            lScore: 655668,
          },
          {
            tJump: {
              lPid: 2327570303,
              lTid: 0,
              lSid: 0,
              iGameId: 0,
              lYYId: 2329504064,
              iRoomId: 16596303,
            },
            tPresenter: {
              lPid: 2327570303,
              sNickName: 'AzZ丶原宝【无敌】',
              sLogoUrl: 'https://huyaimg.msstatic.com/avatar/1009/8b/774616aeb8315632b4a3dec7dcb7b9_180_135.jpg?1570533330',
              sPortait: 'http://livewebbs2.msstatic.com/201912guying.png',
              sBriefText: '主播简介....',
            },
            iRank: 16,
            lScore: 563995,
          },
          {
            tJump: {
              lPid: 2381298545,
              lTid: 1446542755,
              lSid: 1446542755,
              iGameId: 1,
              lYYId: 2383260341,
              iRoomId: 727405,
            },
            tPresenter: {
              lPid: 2381298545,
              sNickName: '血色-小师弟【鸡徒】',
              sLogoUrl: 'https://huyaimg.msstatic.com/avatar/1068/77/4fd0c5575677626be560ce0abfe156_180_135.jpg?1552146855',
              sPortait: 'http://livewebbs2.msstatic.com/201912guying.png',
              sBriefText: '主播简介....',
            },
            iRank: 17,
            lScore: 817992,
          },
          {
            tJump: {
              lPid: 1333322782,
              lTid: 79439506,
              lSid: 79439506,
              iGameId: 897,
              lYYId: 1470446612,
              iRoomId: 254742,
            },
            tPresenter: {
              lPid: 1333322782,
              sNickName: '一声一声丷90058',
              sLogoUrl: 'https://huyaimg.msstatic.com/avatar/1091/07/4ead3876bb0e7d1c2e368023e4b494_180_135.jpg?1566318901',
              sPortait: 'http://livewebbs2.msstatic.com/201912guying.png',
              sBriefText: '主播简介....',
            },
            iRank: 18,
            lScore: 817272,
          },
          {
            tJump: {
              lPid: 2331134035,
              lTid: 0,
              lSid: 0,
              iGameId: 0,
              lYYId: 2332970664,
              iRoomId: 825912,
            },
            tPresenter: {
              lPid: 2331134035,
              sNickName: '念青【三指边缘输出】',
              sLogoUrl: 'https://huyaimg.msstatic.com/avatar/1075/32/9523b21b1fdd4ac6114048dc50d71c_180_135.jpg?1567492584',
              sPortait: 'http://livewebbs2.msstatic.com/201912guying.png',
              sBriefText: '主播简介....',
            },
            iRank: 19,
            lScore: 815759,
          },
          {
            tJump: {
              lPid: 1199516492028,
              lTid: 0,
              lSid: 0,
              iGameId: 0,
              lYYId: 35184380976428,
              iRoomId: 19549893,
            },
            tPresenter: {
              lPid: 1199516492028,
              sNickName: 'Salon-玉瑶',
              sLogoUrl: 'https://huyaimg.msstatic.com/avatar/1083/ff/542e3a2815e529551e0cddad5792f9_180_135.jpg?1574518051',
              sPortait: 'http://livewebbs2.msstatic.com/201912guying.png',
              sBriefText: '主播简介....',
            },
            iRank: 20,
            lScore: 814465,
          },
          {
            tJump: {
              lPid: 2289059331,
              lTid: 0,
              lSid: 0,
              iGameId: 0,
              lYYId: 2289099951,
              iRoomId: 20101345,
            },
            tPresenter: {
              lPid: 2289059331,
              sNickName: '路达-不忘无心',
              sLogoUrl: 'https://huyaimg.msstatic.com/avatar/1049/9f/e12fd738a7b03bfbc77435e6acbc2d_180_135.jpg?1571707151',
              sPortait: 'http://livewebbs2.msstatic.com/201912guying.png',
              sBriefText: '主播简介....',
            },
            iRank: 21,
            lScore: 814333,
          },
          {
            tJump: {
              lPid: 2486039218,
              lTid: 1448621540,
              lSid: 1448621540,
              iGameId: 3203,
              lYYId: 35184420127472,
              iRoomId: 20069849,
            },
            tPresenter: {
              lPid: 2486039218,
              sNickName: 'Dae-猪猪哈',
              sLogoUrl: 'https://huyaimg.msstatic.com/avatar/1027/98/70337488ad3d4cd37f10f47d96faa6_180_135.jpg?1572525664',
              sPortait: 'http://livewebbs2.msstatic.com/201912guying.png',
              sBriefText: '主播简介....',
            },
            iRank: 22,
            lScore: 801372,
          },
          {
            tJump: {
              lPid: 1199524404908,
              lTid: 1199524404908,
              lSid: 1199524404908,
              iGameId: 4,
              lYYId: 35184422499478,
              iRoomId: 20111712,
            },
            tPresenter: {
              lPid: 1199524404908,
              sNickName: 'WH-花姐',
              sLogoUrl: 'https://huyaimg.msstatic.com/avatar/1012/09/aec34f333536da5719bea1d8907863_180_135.jpg?1571836738',
              sPortait: 'http://livewebbs2.msstatic.com/201912guying.png',
              sBriefText: '主播简介....',
            },
            iRank: 23,
            lScore: 791428,
          },
          {
            tJump: {
              lPid: 2223214468,
              lTid: 0,
              lSid: 0,
              iGameId: 0,
              lYYId: 2223523385,
              iRoomId: 17083096,
            },
            tPresenter: {
              lPid: 2223214468,
              sNickName: '蓝新-柔儿吖【921】',
              sLogoUrl: 'https://huyaimg.msstatic.com/avatar/1073/a8/3752d842a6c826ffedc969ea02ae07_180_135.jpg?1573661668',
              sPortait: 'http://livewebbs2.msstatic.com/201912guying.png',
              sBriefText: '主播简介....',
            },
            iRank: 24,
            lScore: 786389,
          },
          {
            tJump: {
              lPid: 106606758,
              lTid: 0,
              lSid: 0,
              iGameId: 0,
              lYYId: 82148338,
              iRoomId: 17625848,
            },
            tPresenter: {
              lPid: 106606758,
              sNickName: 'GR-月儿',
              sLogoUrl: 'https://huyaimg.msstatic.com/avatar/1090/d8/b72c2677d7250213170f9d6949c002_180_135.jpg?1576576813',
              sPortait: 'http://livewebbs2.msstatic.com/201912guying.png',
              sBriefText: '主播简介....',
            },
            iRank: 25,
            lScore: 760980,
          },
          {
            tJump: {
              lPid: 632538737,
              lTid: 0,
              lSid: 0,
              iGameId: 0,
              lYYId: 586273314,
              iRoomId: 18013454,
            },
            tPresenter: {
              lPid: 632538737,
              sNickName: 'KA小月儿',
              sLogoUrl: 'https://huyaimg.msstatic.com/avatar/1048/3a/fab7c4a86793423371c52ee6a19a04_180_135.jpg?1574930067',
              sPortait: 'http://livewebbs2.msstatic.com/201912guying.png',
              sBriefText: '主播简介....',
            },
            iRank: 26,
            lScore: 712241,
          },
          {
            tJump: {
              lPid: 1279512823619,
              lTid: 1279512823619,
              lSid: 1279512823619,
              iGameId: 2336,
              lYYId: 35184383254891,
              iRoomId: 19344927,
            },
            tPresenter: {
              lPid: 1279512823619,
              sNickName: '久爱-小小璐',
              sLogoUrl: 'https://huyaimg.msstatic.com/avatar/1022/ee/a0d928f549a831961394799acd0b7e_180_135.jpg?1564718066',
              sPortait: 'http://livewebbs2.msstatic.com/201912guying.png',
              sBriefText: '主播简介....',
            },
            iRank: 27,
            lScore: 690527,
          },
          {
            tJump: {
              lPid: 1199513349525,
              lTid: 1199513349525,
              lSid: 1199513349525,
              iGameId: 2336,
              lYYId: 35184377393026,
              iRoomId: 17755682,
            },
            tPresenter: {
              lPid: 1199513349525,
              sNickName: '有颜',
              sLogoUrl: 'https://huyaimg.msstatic.com/avatar/1069/97/7981d657c9eeb59a40ad2c92c0e0b1_180_135.jpg?1558164630',
              sPortait: 'http://livewebbs2.msstatic.com/201912guying.png',
              sBriefText: '主播简介....',
            },
            iRank: 28,
            lScore: 653795,
          },
          {
            tJump: {
              lPid: 2303168590,
              lTid: 1421684186,
              lSid: 1421684186,
              iGameId: 1,
              lYYId: 2303229261,
              iRoomId: 16359603,
            },
            tPresenter: {
              lPid: 2303168590,
              sNickName: '二橘呀',
              sLogoUrl: 'https://huyaimg.msstatic.com/avatar/1001/09/cea512d5f51f62c988c41461da2147_180_135.jpg?1572853383',
              sPortait: 'http://livewebbs2.msstatic.com/201912guying.png',
              sBriefText: '主播简介....',
            },
            iRank: 29,
            lScore: 648685,
          },
          {
            tJump: {
              lPid: 2351969968,
              lTid: 0,
              lSid: 0,
              iGameId: 0,
              lYYId: 2353930403,
              iRoomId: 726074,
            },
            tPresenter: {
              lPid: 2351969968,
              sNickName: '久帝-别致',
              sLogoUrl: 'https://huyaimg.msstatic.com/avatar/1000/34/334e4b93e78c27c291c2de4fae5c4b_180_135.jpg?1545707984',
              sPortait: 'http://livewebbs2.msstatic.com/201912guying.png',
              sBriefText: '主播简介....',
            },
            iRank: 30,
            lScore: 640431,
          },
          {
            tJump: {
              lPid: 1548911705,
              lTid: 1446305540,
              lSid: 1446305540,
              iGameId: 3203,
              lYYId: 1743994871,
              iRoomId: 491107,
            },
            tPresenter: {
              lPid: 1548911705,
              sNickName: 'DK-野猫',
              sLogoUrl: 'https://huyaimg.msstatic.com/avatar/1069/5c/e926121338af2f0ab182e3cbd15334_180_135.jpg?1562305841',
              sPortait: 'http://livewebbs2.msstatic.com/201912guying.png',
              sBriefText: '主播简介....',
            },
            iRank: 31,
            lScore: 632644,
          },
          {
            tJump: {
              lPid: 1199513032488,
              lTid: 0,
              lSid: 0,
              iGameId: 0,
              lYYId: 35184377010922,
              iRoomId: 17616000,
            },
            tPresenter: {
              lPid: 1199513032488,
              sNickName: '梁富贵【感恩家人】',
              sLogoUrl: 'https://huyaimg.msstatic.com/avatar/1095/78/fc8873dec804f3743efe5f9b558c97_180_135.jpg?1573421139',
              sPortait: 'http://livewebbs2.msstatic.com/201912guying.png',
              sBriefText: '主播简介....',
            },
            iRank: 32,
            lScore: 603781,
          },
          {
            tJump: {
              lPid: 2355876943,
              lTid: 1446914085,
              lSid: 1446914085,
              iGameId: 2336,
              lYYId: 2357860826,
              iRoomId: 17346002,
            },
            tPresenter: {
              lPid: 2355876943,
              sNickName: '百嘉-狐白',
              sLogoUrl: 'https://huyaimg.msstatic.com/avatar/1084/58/a1dd4bb699298a89d50a9d5c37148a_180_135.jpg?1572085430',
              sPortait: 'http://livewebbs2.msstatic.com/201912guying.png',
              sBriefText: '主播简介....',
            },
            iRank: 33,
            lScore: 764480,
          },
          {
            tJump: {
              lPid: 1259517692680,
              lTid: 0,
              lSid: 0,
              iGameId: 0,
              lYYId: 35184400000206,
              iRoomId: 19542911,
            },
            tPresenter: {
              lPid: 1259517692680,
              sNickName: '星盛-斜阳',
              sLogoUrl: 'https://huyaimg.msstatic.com/avatar/1025/d0/b715d92b56d900dc5d2380c4c74b7f_180_135.jpg?1566458405',
              sPortait: 'http://livewebbs2.msstatic.com/201912guying.png',
              sBriefText: '主播简介....',
            },
            iRank: 34,
            lScore: 763846,
          },
          {
            tJump: {
              lPid: 81265301,
              lTid: 1444684408,
              lSid: 1444684408,
              iGameId: 2336,
              lYYId: 33705615,
              iRoomId: 17500136,
            },
            tPresenter: {
              lPid: 81265301,
              sNickName: '蓝新-无情',
              sLogoUrl: 'https://huyaimg.msstatic.com/avatar/1097/e5/3a465aa462bd999dd8b3f2109659bb_180_135.jpg?1571830628',
              sPortait: 'http://livewebbs2.msstatic.com/201912guying.png',
              sBriefText: '主播简介....',
            },
            iRank: 35,
            lScore: 754601,
          },
          {
            tJump: {
              lPid: 2388066880,
              lTid: 1447360420,
              lSid: 1447360420,
              iGameId: 2336,
              lYYId: 2390102834,
              iRoomId: 18678575,
            },
            tPresenter: {
              lPid: 2388066880,
              sNickName: 'ZY丶小一平',
              sLogoUrl: 'https://huyaimg.msstatic.com/avatar/1021/11/2d711b534a7ee2006fb3893cc0b642_180_135.jpg?1572578126',
              sPortait: 'http://livewebbs2.msstatic.com/201912guying.png',
              sBriefText: '主播简介....',
            },
            iRank: 36,
            lScore: 749139,
          },
          {
            tJump: {
              lPid: 2350669894,
              lTid: 0,
              lSid: 0,
              iGameId: 0,
              lYYId: 2352865340,
              iRoomId: 19907823,
            },
            tPresenter: {
              lPid: 2350669894,
              sNickName: '诺米-李泽言',
              sLogoUrl: 'https://huyaimg.msstatic.com/avatar/1006/a2/26416eab6a0aea0b51e3371d9cdf72_180_135.jpg?1571967431',
              sPortait: 'http://livewebbs2.msstatic.com/201912guying.png',
              sBriefText: '主播简介....',
            },
            iRank: 37,
            lScore: 748369,
          },
          {
            tJump: {
              lPid: 5905294,
              lTid: 0,
              lSid: 0,
              iGameId: 0,
              lYYId: 9303977,
              iRoomId: 190308,
            },
            tPresenter: {
              lPid: 5905294,
              sNickName: 'Dae-马里奥红叔',
              sLogoUrl: 'https://huyaimg.msstatic.com/avatar/1062/19/9b62e85262065ac3f40865bdf39c93_180_135.jpg?1551854393',
              sPortait: 'http://livewebbs2.msstatic.com/201912guying.png',
              sBriefText: '主播简介....',
            },
            iRank: 38,
            lScore: 745129,
          },
          {
            tJump: {
              lPid: 1250697550,
              lTid: 1447298454,
              lSid: 1447298454,
              iGameId: 3203,
              lYYId: 1364722531,
              iRoomId: 836417,
            },
            tPresenter: {
              lPid: 1250697550,
              sNickName: 'Dae-米娅',
              sLogoUrl: 'https://huyaimg.msstatic.com/avatar/1089/8b/cbefdada132d68372e79190e418297_180_135.jpg?1568080061',
              sPortait: 'http://livewebbs2.msstatic.com/201912guying.png',
              sBriefText: '主播简介....',
            },
            iRank: 39,
            lScore: 717622,
          },
          {
            tJump: {
              lPid: 59628029,
              lTid: 0,
              lSid: 0,
              iGameId: 0,
              lYYId: 967702876,
              iRoomId: 19785399,
            },
            tPresenter: {
              lPid: 59628029,
              sNickName: '村长我是一个主播',
              sLogoUrl: 'https://huyaimg.msstatic.com/avatar/1004/98/c42183859317ef41617c905c0cad26_180_135.jpg?1576453503',
              sPortait: 'http://livewebbs2.msstatic.com/201912guying.png',
              sBriefText: '主播简介....',
            },
            iRank: 40,
            lScore: 717128,
          },
          {
            tJump: {
              lPid: 1564987028,
              lTid: 1420738440,
              lSid: 1420738440,
              iGameId: 3203,
              lYYId: 1764223343,
              iRoomId: 622417,
            },
            tPresenter: {
              lPid: 1564987028,
              sNickName: 'Dae-木der',
              sLogoUrl: 'https://huyaimg.msstatic.com/avatar/1048/f2/a28387e689da79c376d3d482b75487_180_135.jpg?1568456920',
              sPortait: 'http://livewebbs2.msstatic.com/201912guying.png',
              sBriefText: '主播简介....',
            },
            iRank: 41,
            lScore: 694270,
          },
          {
            tJump: {
              lPid: 72616392,
              lTid: 0,
              lSid: 0,
              iGameId: 0,
              lYYId: 23376566,
              iRoomId: 950827,
            },
            tPresenter: {
              lPid: 72616392,
              sNickName: '力量哥Lciop',
              sLogoUrl: 'https://huyaimg.msstatic.com/avatar/1028/de/42460fc703bb2a421c7bd42411b332_180_135.jpg?1536064966',
              sPortait: 'http://livewebbs2.msstatic.com/201912guying.png',
              sBriefText: '主播简介....',
            },
            iRank: 42,
            lScore: 687865,
          },
          {
            tJump: {
              lPid: 2339763792,
              lTid: 1444797433,
              lSid: 1444797433,
              iGameId: 2336,
              lYYId: 2341656521,
              iRoomId: 16927869,
            },
            tPresenter: {
              lPid: 2339763792,
              sNickName: '小象丶莫怨',
              sLogoUrl: 'https://huyaimg.msstatic.com/avatar/1019/6c/8bf1bf6ac042f79de53cfb8e5c7e1a_180_135.jpg?1564371671',
              sPortait: 'http://livewebbs2.msstatic.com/201912guying.png',
              sBriefText: '主播简介....',
            },
            iRank: 43,
            lScore: 665446,
          },
          {
            tJump: {
              lPid: 1771196832,
              lTid: 0,
              lSid: 0,
              iGameId: 0,
              lYYId: 2023779575,
              iRoomId: 542612,
            },
            tPresenter: {
              lPid: 1771196832,
              sNickName: 'OK-佳琦',
              sLogoUrl: 'https://huyaimg.msstatic.com/avatar/1020/55/ef7e0cbe4d5a674ff01f3f763c04be_180_135.jpg?1570646779',
              sPortait: 'http://livewebbs2.msstatic.com/201912guying.png',
              sBriefText: '主播简介....',
            },
            iRank: 44,
            lScore: 495383,
          },
          {
            tJump: {
              lPid: 2338016721,
              lTid: 0,
              lSid: 0,
              iGameId: 0,
              lYYId: 2339714408,
              iRoomId: 780361,
            },
            tPresenter: {
              lPid: 2338016721,
              sNickName: '梨栀',
              sLogoUrl: 'https://huyaimg.msstatic.com/avatar/1001/58/588d9a5a5d43db913e5846c622fa8f_180_135.jpg?1576388370',
              sPortait: 'http://livewebbs2.msstatic.com/201912guying.png',
              sBriefText: '主播简介....',
            },
            iRank: 45,
            lScore: 485343,
          },
          {
            tJump: {
              lPid: 118287973,
              lTid: 0,
              lSid: 0,
              iGameId: 0,
              lYYId: 94512993,
              iRoomId: 635477,
            },
            tPresenter: {
              lPid: 118287973,
              sNickName: 'Hz-阿夕吧',
              sLogoUrl: 'https://huyaimg.msstatic.com/avatar/1007/04/a4eaf0464aa59630a94785ac227eff_180_135.jpg?1561940446',
              sPortait: 'http://livewebbs2.msstatic.com/201912guying.png',
              sBriefText: '主播简介....',
            },
            iRank: 46,
            lScore: 460228,
          },
          {
            tJump: {
              lPid: 2496132972,
              lTid: 1448709723,
              lSid: 1448709723,
              iGameId: 2336,
              lYYId: 35184428638138,
              iRoomId: 20265403,
            },
            tPresenter: {
              lPid: 2496132972,
              sNickName: 'Dae-甜桔宝宝',
              sLogoUrl: 'https://huyaimg.msstatic.com/avatar/1026/78/d4e46adb8d8e8a4a83e40ba0c7372b_180_135.jpg?1573535628',
              sPortait: 'http://livewebbs2.msstatic.com/201912guying.png',
              sBriefText: '主播简介....',
            },
            iRank: 47,
            lScore: 406652,
          },
          {
            tJump: {
              lPid: 2299430414,
              lTid: 0,
              lSid: 0,
              iGameId: 0,
              lYYId: 2299404931,
              iRoomId: 598827,
            },
            tPresenter: {
              lPid: 2299430414,
              sNickName: '久帝-甜橘',
              sLogoUrl: 'https://huyaimg.msstatic.com/avatar/1092/62/7b59c994c4bf3392a1663adf0d3ebf_180_135.jpg?1575087040',
              sPortait: 'http://livewebbs2.msstatic.com/201912guying.png',
              sBriefText: '主播简介....',
            },
            iRank: 48,
            lScore: 404342,
          },
          {
            tJump: {
              lPid: 2325765451,
              lTid: 0,
              lSid: 0,
              iGameId: 0,
              lYYId: 2327583096,
              iRoomId: 16568770,
            },
            tPresenter: {
              lPid: 2325765451,
              sNickName: '巅峰-土豆',
              sLogoUrl: 'https://huyaimg.msstatic.com/avatar/1040/20/4ba30a9385ec58ed76174fc548386d_180_135.jpg?1555996273',
              sPortait: 'http://livewebbs2.msstatic.com/201912guying.png',
              sBriefText: '主播简介....',
            },
            iRank: 49,
            lScore: 380489,
          },
          {
            tJump: {
              lPid: 2315283347,
              lTid: 1443833165,
              lSid: 1443833165,
              iGameId: 2336,
              lYYId: 2315334799,
              iRoomId: 16377461,
            },
            tPresenter: {
              lPid: 2315283347,
              sNickName: 'EL-珍惜',
              sLogoUrl: 'https://huyaimg.msstatic.com/avatar/1045/15/2068d9c98700acfba575d6b3543851_180_135.jpg?1554340982',
              sPortait: 'http://livewebbs2.msstatic.com/201912guying.png',
              sBriefText: '主播简介....',
            },
            iRank: 50,
            lScore: 366570,
          },
        ],
      },
      iStage: 5,
      iArea: 1,
      sStageTips: '2019年度游戏新势力主播已经诞生，恭喜以下获奖主播',
    },
    yule: {
      vRank: {
        proto: {
          tJump: {
            lPid: 0,
            lTid: 0,
            lSid: 0,
            iGameId: 0,
            lYYId: 0,
            iRoomId: 0,
          },
          tPresenter: {
            lPid: 0,
            sNickName: '',
            sLogoUrl: '',
            sPortait: '',
            sBriefText: '',
          },
          iRank: 0,
          lScore: 0,
        },
        value: [
          {
            tJump: {
              lPid: 2311156649,
              lTid: 0,
              lSid: 0,
              iGameId: 0,
              lYYId: 90928,
              iRoomId: 928808,
            },
            tPresenter: {
              lPid: 2311156649,
              sNickName: '集梦宝宝',
              sLogoUrl: 'https://huyaimg.msstatic.com/avatar/1066/89/69f868a11b2d888642c899b4f32c68_180_135.jpg?1573663986',
              sPortait: 'https://v-cms-img.huya.com/huya/201912ND/photov1/223.png',
              sBriefText: '主播简介....',
            },
            iRank: 1,
            lScore: 43095451,
          },
          {
            tJump: {
              lPid: 1199517668903,
              lTid: 0,
              lSid: 0,
              iGameId: 0,
              lYYId: 35184384504246,
              iRoomId: 190730,
            },
            tPresenter: {
              lPid: 1199517668903,
              sNickName: '海王HW-洋洋【盼长安】',
              sLogoUrl: 'https://huyaimg.msstatic.com/avatar/1065/11/f7cbd2b15c6f9c2828993eb8672df6_180_135.jpg?1576263821',
              sPortait: 'https://v-cms-img.huya.com/huya/201912ND/photov1/227.png',
              sBriefText: '主播简介....',
            },
            iRank: 2,
            lScore: 34833614,
          },
          {
            tJump: {
              lPid: 1116857,
              lTid: 0,
              lSid: 0,
              iGameId: 0,
              lYYId: 19655000,
              iRoomId: 520852,
            },
            tPresenter: {
              lPid: 1116857,
              sNickName: 'Dae-怀念',
              sLogoUrl: 'https://huyaimg.msstatic.com/avatar/1098/1b/f2d567884cbb50e41eaf6c38bbf566_180_135.jpg?1569512746',
              sPortait: 'http://livewebbs2.msstatic.com/201912guying.png',
              sBriefText: '主播简介....',
            },
            iRank: 3,
            lScore: 31255800,
          },
          {
            tJump: {
              lPid: 2178953218,
              lTid: 0,
              lSid: 0,
              iGameId: 0,
              lYYId: 2178879593,
              iRoomId: 520006,
            },
            tPresenter: {
              lPid: 2178953218,
              sNickName: '依然是婷er【006】',
              sLogoUrl: 'https://huyaimg.msstatic.com/avatar/1060/ce/6f544432cefbb3c322c4fd143b01fb_180_135.jpg?1569067537',
              sPortait: 'https://v-cms-img.huya.com/huya/201912ND/photov1/225.png',
              sBriefText: '百变女神皮皮婷，甜美的长相，性感的身材，会唱会跳',
            },
            iRank: 4,
            lScore: 6134641,
          },
          {
            tJump: {
              lPid: 392202648,
              lTid: 0,
              lSid: 0,
              iGameId: 0,
              lYYId: 306657083,
              iRoomId: 520637,
            },
            tPresenter: {
              lPid: 392202648,
              sNickName: '血色-刘杀鸡【精神股东',
              sLogoUrl: 'https://huyaimg.msstatic.com/avatar/1088/43/04e80eec072cdbfc4b9c2c4c655a1f_180_135.jpg?1546149084',
              sPortait: 'http://livewebbs2.msstatic.com/201912guying.png',
              sBriefText: '主播简介....',
            },
            iRank: 5,
            lScore: 4600316,
          },
          {
            tJump: {
              lPid: 1786372890,
              lTid: 0,
              lSid: 0,
              iGameId: 0,
              lYYId: 2038972929,
              iRoomId: 926626,
            },
            tPresenter: {
              lPid: 1786372890,
              sNickName: '626-江澜【尊师放纵】',
              sLogoUrl: 'https://huyaimg.msstatic.com/avatar/1088/98/147e08afa9962b2ffba5692bb40015_180_135.jpg?1560397453',
              sPortait: 'https://v-cms-img.huya.com/huya/201912ND/photov1/222.png',
              sBriefText: '主播简介....',
            },
            iRank: 6,
            lScore: 4944941,
          },
          {
            tJump: {
              lPid: 1673106460,
              lTid: 0,
              lSid: 0,
              iGameId: 0,
              lYYId: 1904038917,
              iRoomId: 920733,
            },
            tPresenter: {
              lPid: 1673106460,
              sNickName: '集梦钱多多',
              sLogoUrl: 'https://huyaimg.msstatic.com/avatar/1066/bb/6874e6a794bb01ef9a96a31d3f9fa1_180_135.jpg?1573033477',
              sPortait: 'http://livewebbs2.msstatic.com/201912guying.png',
              sBriefText: '主播简介....',
            },
            iRank: 7,
            lScore: 3969293,
          },
          {
            tJump: {
              lPid: 1613898913,
              lTid: 0,
              lSid: 0,
              iGameId: 0,
              lYYId: 1827812559,
              iRoomId: 19193231,
            },
            tPresenter: {
              lPid: 1613898913,
              sNickName: '付宁宁',
              sLogoUrl: 'https://huyaimg.msstatic.com/avatar/1070/c5/3b27a902f7f537f3cdef839c79731c_180_135.jpg?1571523518',
              sPortait: 'http://livewebbs2.msstatic.com/201912guying.png',
              sBriefText: '主播简介....',
            },
            iRank: 8,
            lScore: 3957035,
          },
          {
            tJump: {
              lPid: 1199518828666,
              lTid: 0,
              lSid: 0,
              iGameId: 0,
              lYYId: 35184393089978,
              iRoomId: 52007,
            },
            tPresenter: {
              lPid: 1199518828666,
              sNickName: '奇领小鲁班',
              sLogoUrl: 'https://huyaimg.msstatic.com/avatar/1070/ad/619cee97998fa27b31f64e8df23836_180_135.jpg?1573570456',
              sPortait: 'https://v-cms-img.huya.com/huya/201912ND/photov1/203.png',
              sBriefText: '星秀暖心系歌手，游戏搞笑型选手',
            },
            iRank: 9,
            lScore: 3151504,
          },
          {
            tJump: {
              lPid: 1561330435,
              lTid: 1340694324,
              lSid: 1340694324,
              iGameId: 1663,
              lYYId: 1760210470,
              iRoomId: 105110,
            },
            tPresenter: {
              lPid: 1561330435,
              sNickName: '【大事件】贝勒爷【寸】',
              sLogoUrl: 'https://huyaimg.msstatic.com/avatar/1018/93/701ee1851f11a91721020dcf4d8b76_180_135.jpg?1540658484',
              sPortait: 'http://livewebbs2.msstatic.com/201912guying.png',
              sBriefText: '主播简介....',
            },
            iRank: 10,
            lScore: 2640942,
          },
          {
            tJump: {
              lPid: 1199512383897,
              lTid: 0,
              lSid: 0,
              iGameId: 0,
              lYYId: 35184376136155,
              iRoomId: 508504,
            },
            tPresenter: {
              lPid: 1199512383897,
              sNickName: '正恒丶有位乔【余生】',
              sLogoUrl: 'https://huyaimg.msstatic.com/avatar/1056/20/602609c16ab551b0ddf460c25f31d4_180_135.jpg?1565356481',
              sPortait: 'http://livewebbs2.msstatic.com/201912guying.png',
              sBriefText: '主播简介....',
            },
            iRank: 11,
            lScore: 3254427,
          },
          {
            tJump: {
              lPid: 1342232319,
              lTid: 0,
              lSid: 0,
              iGameId: 0,
              lYYId: 1481303980,
              iRoomId: 664953,
            },
            tPresenter: {
              lPid: 1342232319,
              sNickName: 'sgn-肖妹儿',
              sLogoUrl: 'https://huyaimg.msstatic.com/avatar/1053/a1/16a91f3bbf3964363087f7f96f003e_180_135.jpg?1575485945',
              sPortait: 'http://livewebbs2.msstatic.com/201912guying.png',
              sBriefText: '主播简介....',
            },
            iRank: 12,
            lScore: 3080134,
          },
          {
            tJump: {
              lPid: 504718172,
              lTid: 0,
              lSid: 0,
              iGameId: 0,
              lYYId: 427757292,
              iRoomId: 592010,
            },
            tPresenter: {
              lPid: 504718172,
              sNickName: '赢城LZ-正经赵',
              sLogoUrl: 'https://huyaimg.msstatic.com/avatar/1012/55/535cc9f2a994fbdf233db833adf6b5_180_135.jpg?1567603217',
              sPortait: 'http://livewebbs2.msstatic.com/201912guying.png',
              sBriefText: '主播简介....',
            },
            iRank: 13,
            lScore: 2480995,
          },
          {
            tJump: {
              lPid: 1199522228025,
              lTid: 0,
              lSid: 0,
              iGameId: 0,
              lYYId: 35184409625741,
              iRoomId: 947785,
            },
            tPresenter: {
              lPid: 1199522228025,
              sNickName: 'GR-Glg-小阿俏',
              sLogoUrl: 'https://huyaimg.msstatic.com/avatar/1056/63/46c8c6c8f9d0c9ad2cb3c60593196b_180_135.jpg?1574587798',
              sPortait: 'http://livewebbs2.msstatic.com/201912guying.png',
              sBriefText: '主播简介....',
            },
            iRank: 14,
            lScore: 1584452,
          },
          {
            tJump: {
              lPid: 92300143,
              lTid: 0,
              lSid: 0,
              iGameId: 0,
              lYYId: 45958951,
              iRoomId: 381196,
            },
            tPresenter: {
              lPid: 92300143,
              sNickName: '正恒-橘之【一定行】',
              sLogoUrl: 'https://huyaimg.msstatic.com/avatar/1068/f7/df314bf8330758b487b88a84fd6bcf_180_135.jpg?1576064893',
              sPortait: 'http://livewebbs2.msstatic.com/201912guying.png',
              sBriefText: '主播简介....',
            },
            iRank: 15,
            lScore: 1451769,
          },
          {
            tJump: {
              lPid: 1341494715,
              lTid: 1447235096,
              lSid: 1447235096,
              iGameId: 1663,
              lYYId: 1480642982,
              iRoomId: 426160,
            },
            tPresenter: {
              lPid: 1341494715,
              sNickName: 'YH丶啦啦',
              sLogoUrl: 'https://huyaimg.msstatic.com/avatar/1078/54/6a8aa3c2bc44ecf237f5775ebde01c_180_135.jpg?1575212596',
              sPortait: 'http://livewebbs2.msstatic.com/201912guying.png',
              sBriefText: '主播简介....',
            },
            iRank: 16,
            lScore: 930882,
          },
          {
            tJump: {
              lPid: 1843601770,
              lTid: 0,
              lSid: 0,
              iGameId: 0,
              lYYId: 2096239932,
              iRoomId: 492966,
            },
            tPresenter: {
              lPid: 1843601770,
              sNickName: '正恒YZ-冰冰',
              sLogoUrl: 'https://huyaimg.msstatic.com/avatar/1074/94/c3006c508db3f313ca578c73a5cedc_180_135.jpg?1572925736',
              sPortait: 'http://livewebbs2.msstatic.com/201912guying.png',
              sBriefText: '主播简介....',
            },
            iRank: 17,
            lScore: 1385911,
          },
          {
            tJump: {
              lPid: 93361084,
              lTid: 0,
              lSid: 0,
              iGameId: 0,
              lYYId: 47154397,
              iRoomId: 16020077,
            },
            tPresenter: {
              lPid: 93361084,
              sNickName: '影娱-梦雨',
              sLogoUrl: 'https://huyaimg.msstatic.com/avatar/1084/4f/64f281c1fd325c976a0b209a29f960_180_135.jpg?1554620054',
              sPortait: 'http://livewebbs2.msstatic.com/201912guying.png',
              sBriefText: '主播简介....',
            },
            iRank: 18,
            lScore: 1383726,
          },
          {
            tJump: {
              lPid: 1199515615774,
              lTid: 0,
              lSid: 0,
              iGameId: 0,
              lYYId: 35184380055108,
              iRoomId: 125871,
            },
            tPresenter: {
              lPid: 1199515615774,
              sNickName: '话社-米粒儿',
              sLogoUrl: 'https://huyaimg.msstatic.com/avatar/1046/7c/f3f9a61853a95932ea59be8125497e_180_135.jpg?1567175976',
              sPortait: 'http://livewebbs2.msstatic.com/201912guying.png',
              sBriefText: '主播简介....',
            },
            iRank: 19,
            lScore: 1362811,
          },
          {
            tJump: {
              lPid: 2324429504,
              lTid: 1444147678,
              lSid: 1444147678,
              iGameId: 1663,
              lYYId: 2326347671,
              iRoomId: 529365,
            },
            tPresenter: {
              lPid: 2324429504,
              sNickName: '小九九vin、赢城YC',
              sLogoUrl: 'https://huyaimg.msstatic.com/avatar/1087/2e/117a7603b1608e7ff61ed0d7205b16_180_135.jpg?1576595503',
              sPortait: 'http://livewebbs2.msstatic.com/201912guying.png',
              sBriefText: '主播简介....',
            },
            iRank: 20,
            lScore: 1289783,
          },
          {
            tJump: {
              lPid: 1327830457,
              lTid: 0,
              lSid: 0,
              iGameId: 0,
              lYYId: 1463093668,
              iRoomId: 783018,
            },
            tPresenter: {
              lPid: 1327830457,
              sNickName: 'KD-佳多宝姐姐',
              sLogoUrl: 'https://huyaimg.msstatic.com/avatar/1046/c1/3edc6032b7fd0465f020ccb6975535_180_135.jpg?1572043276',
              sPortait: 'http://livewebbs2.msstatic.com/201912guying.png',
              sBriefText: '主播简介....',
            },
            iRank: 21,
            lScore: 1282188,
          },
          {
            tJump: {
              lPid: 1641670810,
              lTid: 0,
              lSid: 0,
              iGameId: 0,
              lYYId: 1862470579,
              iRoomId: 315653,
            },
            tPresenter: {
              lPid: 1641670810,
              sNickName: '小琳琳吖、',
              sLogoUrl: 'https://huyaimg.msstatic.com/avatar/1093/f8/838793ce1bcbb527cb257944187dff_180_135.jpg?1575816447',
              sPortait: 'http://livewebbs2.msstatic.com/201912guying.png',
              sBriefText: '主播简介....',
            },
            iRank: 22,
            lScore: 1281824,
          },
          {
            tJump: {
              lPid: 1199512672740,
              lTid: 1199512672740,
              lSid: 1199512672740,
              iGameId: 1663,
              lYYId: 35184376537000,
              iRoomId: 779518,
            },
            tPresenter: {
              lPid: 1199512672740,
              sNickName: '集梦大静静',
              sLogoUrl: 'https://huyaimg.msstatic.com/avatar/1052/83/c944cc4e3a1c8124453e0ad90a077a_180_135.jpg?1560958267',
              sPortait: 'http://livewebbs2.msstatic.com/201912guying.png',
              sBriefText: '主播简介....',
            },
            iRank: 23,
            lScore: 1269855,
          },
          {
            tJump: {
              lPid: 1357766372,
              lTid: 0,
              lSid: 0,
              iGameId: 0,
              lYYId: 1502242798,
              iRoomId: 170153,
            },
            tPresenter: {
              lPid: 1357766372,
              sNickName: '乐享、知知',
              sLogoUrl: 'https://huyaimg.msstatic.com/avatar/1007/a7/e71b77b96ad5437a688052b70754c5_180_135.jpg?1576157767',
              sPortait: 'http://livewebbs2.msstatic.com/201912guying.png',
              sBriefText: '主播简介....',
            },
            iRank: 24,
            lScore: 1251741,
          },
          {
            tJump: {
              lPid: 2180301975,
              lTid: 0,
              lSid: 0,
              iGameId: 0,
              lYYId: 2180565503,
              iRoomId: 734081,
            },
            tPresenter: {
              lPid: 2180301975,
              sNickName: 'AzZ丶诗然',
              sLogoUrl: 'https://huyaimg.msstatic.com/avatar/1045/43/634e12523c1c68047fb2c7490586dc_180_135.jpg?1556565353',
              sPortait: 'http://livewebbs2.msstatic.com/201912guying.png',
              sBriefText: '主播简介....',
            },
            iRank: 25,
            lScore: 1240878,
          },
          {
            tJump: {
              lPid: 1279517630950,
              lTid: 0,
              lSid: 0,
              iGameId: 0,
              lYYId: 35184409327779,
              iRoomId: 19712586,
            },
            tPresenter: {
              lPid: 1279517630950,
              sNickName: '赢城YC-缘缘',
              sLogoUrl: 'https://huyaimg.msstatic.com/avatar/1020/fb/dc7840f0ca82116bec1b94b6c4d945_180_135.jpg?1576451332',
              sPortait: 'http://livewebbs2.msstatic.com/201912guying.png',
              sBriefText: '主播简介....',
            },
            iRank: 26,
            lScore: 1225983,
          },
          {
            tJump: {
              lPid: 1199524639536,
              lTid: 0,
              lSid: 0,
              iGameId: 0,
              lYYId: 35184423492400,
              iRoomId: 20140993,
            },
            tPresenter: {
              lPid: 1199524639536,
              sNickName: '唐诗恩',
              sLogoUrl: 'https://huyaimg.msstatic.com/avatar/1084/9a/9e2c82452734190a6853e01ea5d8d5_180_135.jpg?1575762076',
              sPortait: 'http://livewebbs2.msstatic.com/201912guying.png',
              sBriefText: '主播简介....',
            },
            iRank: 27,
            lScore: 1095682,
          },
          {
            tJump: {
              lPid: 2344297241,
              lTid: 0,
              lSid: 0,
              iGameId: 0,
              lYYId: 2346189601,
              iRoomId: 17034729,
            },
            tPresenter: {
              lPid: 2344297241,
              sNickName: '艾泽-小思语',
              sLogoUrl: 'https://huyaimg.msstatic.com/avatar/1023/84/3ae277b4cf3cb5ba019b1337eb1b6e_180_135.jpg?1575649893',
              sPortait: 'http://livewebbs2.msstatic.com/201912guying.png',
              sBriefText: '主播简介....',
            },
            iRank: 28,
            lScore: 1078890,
          },
          {
            tJump: {
              lPid: 1323811700,
              lTid: 0,
              lSid: 0,
              iGameId: 0,
              lYYId: 1458612590,
              iRoomId: 562160,
            },
            tPresenter: {
              lPid: 1323811700,
              sNickName: '正恒YJ-小恩宝',
              sLogoUrl: 'https://huyaimg.msstatic.com/avatar/1060/a2/74c286a6e6a612cfc5ddd66c122638_180_135.jpg?1574818376',
              sPortait: 'http://livewebbs2.msstatic.com/201912guying.png',
              sBriefText: '主播简介....',
            },
            iRank: 29,
            lScore: 1030864,
          },
          {
            tJump: {
              lPid: 1085699818,
              lTid: 0,
              lSid: 0,
              iGameId: 0,
              lYYId: 1154682805,
              iRoomId: 153271,
            },
            tPresenter: {
              lPid: 1085699818,
              sNickName: '歆娱丶樱花',
              sLogoUrl: 'https://huyaimg.msstatic.com/avatar/1041/49/f5e59b650e86a7b66f404e6f29ca48_180_135.jpg?1566766627',
              sPortait: 'http://livewebbs2.msstatic.com/201912guying.png',
              sBriefText: '主播简介....',
            },
            iRank: 30,
            lScore: 988486,
          },
          {
            tJump: {
              lPid: 1259512717299,
              lTid: 0,
              lSid: 0,
              iGameId: 0,
              lYYId: 35184382731078,
              iRoomId: 610451,
            },
            tPresenter: {
              lPid: 1259512717299,
              sNickName: '娱加-芊音【星徒】',
              sLogoUrl: 'https://huyaimg.msstatic.com/avatar/1082/ae/b42a6dfedf5a80a55601f175fbc9ba_180_135.jpg?1576511129',
              sPortait: 'http://livewebbs2.msstatic.com/201912guying.png',
              sBriefText: '主播简介....',
            },
            iRank: 31,
            lScore: 906950,
          },
          {
            tJump: {
              lPid: 1199523599560,
              lTid: 0,
              lSid: 0,
              iGameId: 0,
              lYYId: 35184418342415,
              iRoomId: 175485,
            },
            tPresenter: {
              lPid: 1199523599560,
              sNickName: '中国蓝、钢镚',
              sLogoUrl: 'https://huyaimg.msstatic.com/avatar/1086/88/38f86ccfbb086ca48e5cd266f84d88_180_135.jpg?1570945029',
              sPortait: 'http://livewebbs2.msstatic.com/201912guying.png',
              sBriefText: '主播简介....',
            },
            iRank: 32,
            lScore: 838968,
          },
          {
            tJump: {
              lPid: 2455213861,
              lTid: 1447561753,
              lSid: 1447561753,
              iGameId: 1663,
              lYYId: 2406902741,
              iRoomId: 737256,
            },
            tPresenter: {
              lPid: 2455213861,
              sNickName: '灵石-荔枝',
              sLogoUrl: 'https://huyaimg.msstatic.com/avatar/1069/57/466652e28abb8fd7151b1042cd9b60_180_135.jpg?1567339798',
              sPortait: 'http://livewebbs2.msstatic.com/201912guying.png',
              sBriefText: '主播简介....',
            },
            iRank: 33,
            lScore: 1203963,
          },
          {
            tJump: {
              lPid: 2252866515,
              lTid: 0,
              lSid: 0,
              iGameId: 0,
              lYYId: 2254036709,
              iRoomId: 224507,
            },
            tPresenter: {
              lPid: 2252866515,
              sNickName: '集梦志峰【坦克团】',
              sLogoUrl: 'https://huyaimg.msstatic.com/avatar/1007/50/511c3b756f4e93f96ed818d4fc52d4_180_135.jpg?1552836224',
              sPortait: 'http://livewebbs2.msstatic.com/201912guying.png',
              sBriefText: '主播简介....',
            },
            iRank: 34,
            lScore: 1184492,
          },
          {
            tJump: {
              lPid: 2379830449,
              lTid: 1446462489,
              lSid: 1446462489,
              iGameId: 1663,
              lYYId: 2381664796,
              iRoomId: 735131,
            },
            tPresenter: {
              lPid: 2379830449,
              sNickName: '正恒-我是梓铭啊',
              sLogoUrl: 'https://huyaimg.msstatic.com/avatar/1042/32/86c6ad97f359f8de29288ee8c7a53e_180_135.jpg?1554192652',
              sPortait: 'http://livewebbs2.msstatic.com/201912guying.png',
              sBriefText: '主播简介....',
            },
            iRank: 35,
            lScore: 1174414,
          },
          {
            tJump: {
              lPid: 1825424045,
              lTid: 0,
              lSid: 0,
              iGameId: 0,
              lYYId: 2078038944,
              iRoomId: 932822,
            },
            tPresenter: {
              lPid: 1825424045,
              sNickName: '林画',
              sLogoUrl: 'https://huyaimg.msstatic.com/avatar/1058/52/c4d52fa9415a6b8ab3d05025a8c861_180_135.jpg?1558430100',
              sPortait: 'http://livewebbs2.msstatic.com/201912guying.png',
              sBriefText: '主播简介....',
            },
            iRank: 36,
            lScore: 1163445,
          },
          {
            tJump: {
              lPid: 1442609801,
              lTid: 0,
              lSid: 0,
              iGameId: 0,
              lYYId: 1609234652,
              iRoomId: 529155,
            },
            tPresenter: {
              lPid: 1442609801,
              sNickName: '汤维维【尊师画心】',
              sLogoUrl: 'https://huyaimg.msstatic.com/avatar/1018/86/bb17ed0124f09bc3fda3951d7bea87_180_135.jpg?1572911960',
              sPortait: 'http://livewebbs2.msstatic.com/201912guying.png',
              sBriefText: '主播简介....',
            },
            iRank: 37,
            lScore: 1145904,
          },
          {
            tJump: {
              lPid: 1328472502,
              lTid: 0,
              lSid: 0,
              iGameId: 0,
              lYYId: 1463510020,
              iRoomId: 703815,
            },
            tPresenter: {
              lPid: 1328472502,
              sNickName: '正恒YJ-米乐小饼干',
              sLogoUrl: 'https://huyaimg.msstatic.com/avatar/1026/ab/ba55ef6be5070c5f98a264562d0cc4_180_135.jpg?1571725197',
              sPortait: 'http://livewebbs2.msstatic.com/201912guying.png',
              sBriefText: '主播简介....',
            },
            iRank: 38,
            lScore: 1143415,
          },
          {
            tJump: {
              lPid: 1199514317764,
              lTid: 0,
              lSid: 0,
              iGameId: 0,
              lYYId: 35184378511131,
              iRoomId: 714266,
            },
            tPresenter: {
              lPid: 1199514317764,
              sNickName: '赢城YC-加肥猫w【宠爱】',
              sLogoUrl: 'https://huyaimg.msstatic.com/avatar/1056/98/40eb0fc0c1ec1b9ecbadba0adfca9f_180_135.jpg?1575587935',
              sPortait: 'http://livewebbs2.msstatic.com/201912guying.png',
              sBriefText: '主播简介....',
            },
            iRank: 39,
            lScore: 1127365,
          },
          {
            tJump: {
              lPid: 1152629002,
              lTid: 0,
              lSid: 0,
              iGameId: 0,
              lYYId: 1240427381,
              iRoomId: 405683,
            },
            tPresenter: {
              lPid: 1152629002,
              sNickName: '阿稀稀大魔王',
              sLogoUrl: 'https://huyaimg.msstatic.com/avatar/1026/44/cb42e00eeaa7a497097d5f7d577a9c_180_135.jpg?1574772995',
              sPortait: 'http://livewebbs2.msstatic.com/201912guying.png',
              sBriefText: '主播简介....',
            },
            iRank: 40,
            lScore: 1068054,
          },
          {
            tJump: {
              lPid: 1199514027098,
              lTid: 0,
              lSid: 0,
              iGameId: 0,
              lYYId: 35184378169124,
              iRoomId: 520098,
            },
            tPresenter: {
              lPid: 1199514027098,
              sNickName: '正恒YJ-晚安安',
              sLogoUrl: 'https://huyaimg.msstatic.com/avatar/1014/da/2dcfe27b93d3bfb057b0da62655e3c_180_135.jpg?1574405652',
              sPortait: 'http://livewebbs2.msstatic.com/201912guying.png',
              sBriefText: '主播简介....',
            },
            iRank: 41,
            lScore: 1061913,
          },
          {
            tJump: {
              lPid: 1848086354,
              lTid: 1446842165,
              lSid: 1446842165,
              iGameId: 1663,
              lYYId: 2100697597,
              iRoomId: 520323,
            },
            tPresenter: {
              lPid: 1848086354,
              sNickName: '葫芦妹er【323】',
              sLogoUrl: 'https://huyaimg.msstatic.com/avatar/1019/70/aec1f5e88d4ae56909386c92f42102_180_135.jpg?1564626962',
              sPortait: 'http://livewebbs2.msstatic.com/201912guying.png',
              sBriefText: '主播简介....',
            },
            iRank: 42,
            lScore: 1055630,
          },
          {
            tJump: {
              lPid: 2183570729,
              lTid: 0,
              lSid: 0,
              iGameId: 0,
              lYYId: 2183808568,
              iRoomId: 537443,
            },
            tPresenter: {
              lPid: 2183570729,
              sNickName: '清风-宅我乐',
              sLogoUrl: 'https://huyaimg.msstatic.com/avatar/1060/0e/fcfa496b0154c4beda375881c08994_180_135.jpg?1564899334',
              sPortait: 'http://livewebbs2.msstatic.com/201912guying.png',
              sBriefText: '主播简介....',
            },
            iRank: 43,
            lScore: 1044803,
          },
          {
            tJump: {
              lPid: 2312086388,
              lTid: 0,
              lSid: 0,
              iGameId: 0,
              lYYId: 2312234052,
              iRoomId: 16322412,
            },
            tPresenter: {
              lPid: 2312086388,
              sNickName: '嘉仁-大美小可爱渣吗',
              sLogoUrl: 'https://huyaimg.msstatic.com/avatar/1075/1c/5e84b9009d32f0dcf438378faab20e_180_135.jpg?1576477831',
              sPortait: 'http://livewebbs2.msstatic.com/201912guying.png',
              sBriefText: '主播简介....',
            },
            iRank: 44,
            lScore: 929168,
          },
          {
            tJump: {
              lPid: 2297371393,
              lTid: 1448025391,
              lSid: 1448025391,
              iGameId: 2165,
              lYYId: 2297369655,
              iRoomId: 501781,
            },
            tPresenter: {
              lPid: 2297371393,
              sNickName: '微山湖户外【赢城】',
              sLogoUrl: 'https://huyaimg.msstatic.com/avatar/1094/17/335aa900444f38cef49f1be84a1d69_180_135.jpg?1573909933',
              sPortait: 'https://v-cms-img.huya.com/huya/201912ND/photov1/211.png',
              sBriefText: '全能型打野主播，带你捕鱼摸虾体验乡野欢乐',
            },
            iRank: 45,
            lScore: 897636,
          },
          {
            tJump: {
              lPid: 1199519494937,
              lTid: 0,
              lSid: 0,
              iGameId: 0,
              lYYId: 35184396075229,
              iRoomId: 82061,
            },
            tPresenter: {
              lPid: 1199519494937,
              sNickName: '血色-绿见',
              sLogoUrl: 'https://huyaimg.msstatic.com/avatar/1048/02/498f0ffabc4df9596f55a8709b5f0f_180_135.jpg?1574057227',
              sPortait: 'http://livewebbs2.msstatic.com/201912guying.png',
              sBriefText: '主播简介....',
            },
            iRank: 46,
            lScore: 769765,
          },
          {
            tJump: {
              lPid: 1199516606325,
              lTid: 0,
              lSid: 0,
              iGameId: 0,
              lYYId: 35184381118008,
              iRoomId: 934960,
            },
            tPresenter: {
              lPid: 1199516606325,
              sNickName: '蛋炒饭同学',
              sLogoUrl: 'https://huyaimg.msstatic.com/avatar/1016/92/fae247727d4e60b23ea0361f823453_180_135.jpg?1573419959',
              sPortait: 'http://livewebbs2.msstatic.com/201912guying.png',
              sBriefText: '主播简介....',
            },
            iRank: 47,
            lScore: 711021,
          },
          {
            tJump: {
              lPid: 1199518757910,
              lTid: 0,
              lSid: 0,
              iGameId: 0,
              lYYId: 35184392599111,
              iRoomId: 190634,
            },
            tPresenter: {
              lPid: 1199518757910,
              sNickName: '赢城LZ-林真心',
              sLogoUrl: 'https://huyaimg.msstatic.com/avatar/1089/8e/0571912424e86c799dabcb94a1b753_180_135.jpg?1576171556',
              sPortait: 'http://livewebbs2.msstatic.com/201912guying.png',
              sBriefText: '主播简介....',
            },
            iRank: 48,
            lScore: 699533,
          },
          {
            tJump: {
              lPid: 1199514880243,
              lTid: 0,
              lSid: 0,
              iGameId: 0,
              lYYId: 35184379170914,
              iRoomId: 848871,
            },
            tPresenter: {
              lPid: 1199514880243,
              sNickName: '炎帝-若梦',
              sLogoUrl: 'https://huyaimg.msstatic.com/avatar/1027/fb/ddb135c9e64f48b1c85a3cb65aca71_180_135.jpg?1570504600',
              sPortait: 'http://livewebbs2.msstatic.com/201912guying.png',
              sBriefText: '主播简介....',
            },
            iRank: 49,
            lScore: 671424,
          },
          {
            tJump: {
              lPid: 1259517931783,
              lTid: 0,
              lSid: 0,
              iGameId: 0,
              lYYId: 35184401356437,
              iRoomId: 613472,
            },
            tPresenter: {
              lPid: 1259517931783,
              sNickName: '小笙笙',
              sLogoUrl: 'https://huyaimg.msstatic.com/avatar/1006/a3/2228eb89afafaa0755640541cd3b14_180_135.jpg?1570783075',
              sPortait: 'http://livewebbs2.msstatic.com/201912guying.png',
              sBriefText: '主播简介....',
            },
            iRank: 50,
            lScore: 643884,
          },
        ],
      },
      iStage: 5,
      iArea: 2,
      sStageTips: '2019年度娱乐新势力主播已经诞生，恭喜以下获奖主播',
    },
    jiaoyou: {
      vRank: {
        proto: {
          tJump: {
            lPid: 0,
            lTid: 0,
            lSid: 0,
            iGameId: 0,
            lYYId: 0,
            iRoomId: 0,
          },
          tPresenter: {
            lPid: 0,
            sNickName: '',
            sLogoUrl: '',
            sPortait: '',
            sBriefText: '',
          },
          iRank: 0,
          lScore: 0,
        },
        value: [
          {
            tJump: {
              lPid: 1199525690638,
              lTid: 1199525690638,
              lSid: 1199525690638,
              iGameId: 4079,
              lYYId: 35184429394323,
              iRoomId: 20299925,
            },
            tPresenter: {
              lPid: 1199525690638,
              sNickName: 'Agony-鲸落十里',
              sLogoUrl: 'https://huyaimg.msstatic.com/avatar/1090/c2/25e0a7ee40a57f02feca30c02afb46_180_135.jpg?1573964281',
              sPortait: 'http://livewebbs2.msstatic.com/201912guying.png',
              sBriefText: '主播简介....',
            },
            iRank: 1,
            lScore: 3421006,
          },
          {
            tJump: {
              lPid: 2392215264,
              lTid: 1447970341,
              lSid: 1447970341,
              iGameId: 4079,
              lYYId: 2394157604,
              iRoomId: 19179543,
            },
            tPresenter: {
              lPid: 2392215264,
              sNickName: '豪门-纸迷金醉',
              sLogoUrl: 'https://huyaimg.msstatic.com/avatar/1024/49/2ef78a32500a08f916d25d4fce1ac9_180_135.jpg?1563626692',
              sPortait: 'http://livewebbs2.msstatic.com/201912guying.png',
              sBriefText: '主播简介....',
            },
            iRank: 2,
            lScore: 3280624,
          },
          {
            tJump: {
              lPid: 362894679,
              lTid: 66228146,
              lSid: 66228146,
              iGameId: 4079,
              lYYId: 275688951,
              iRoomId: 18320593,
            },
            tPresenter: {
              lPid: 362894679,
              sNickName: '98-一起鬼混',
              sLogoUrl: 'https://huyaimg.msstatic.com/avatar/1071/37/059cf96b0672714ed8192f3659111f_180_135.jpg?1576587419',
              sPortait: 'http://livewebbs2.msstatic.com/201912guying.png',
              sBriefText: '主播简介....',
            },
            iRank: 3,
            lScore: 2253322,
          },
          {
            tJump: {
              lPid: 873479969,
              lTid: 1446422620,
              lSid: 1446422620,
              iGameId: 4079,
              lYYId: 836277351,
              iRoomId: 520139,
            },
            tPresenter: {
              lPid: 873479969,
              sNickName: 'Top-连麦吗',
              sLogoUrl: 'https://huyaimg.msstatic.com/avatar/1053/ff/4842542b64a956a07724307f65812f_180_135.jpg?1563874218',
              sPortait: 'http://livewebbs2.msstatic.com/201912guying.png',
              sBriefText: '主播简介....',
            },
            iRank: 4,
            lScore: 2008505,
          },
          {
            tJump: {
              lPid: 1199520750386,
              lTid: 1199520750386,
              lSid: 1199520750386,
              iGameId: 4079,
              lYYId: 35184402593840,
              iRoomId: 19553428,
            },
            tPresenter: {
              lPid: 1199520750386,
              sNickName: '豪门-你的妹妹',
              sLogoUrl: 'https://huyaimg.msstatic.com/avatar/1018/ea/1e28e2379c34eacc6c2bf3a4fd40e1_180_135.jpg?1574509442',
              sPortait: 'http://livewebbs2.msstatic.com/201912guying.png',
              sBriefText: '主播简介....',
            },
            iRank: 5,
            lScore: 1107640,
          },
          {
            tJump: {
              lPid: 120130088,
              lTid: 1447113562,
              lSid: 1447113562,
              iGameId: 4079,
              lYYId: 96432890,
              iRoomId: 470286,
            },
            tPresenter: {
              lPid: 120130088,
              sNickName: '血色-随心所欲',
              sLogoUrl: 'https://huyaimg.msstatic.com/avatar/1033/4b/2594d06a7e64c45c199accb2f09960_180_135.jpg?1573929917',
              sPortait: 'http://livewebbs2.msstatic.com/201912guying.png',
              sBriefText: '主播简介....',
            },
            iRank: 6,
            lScore: 1279926,
          },
          {
            tJump: {
              lPid: 2251035523,
              lTid: 1421363756,
              lSid: 1421363756,
              iGameId: 4079,
              lYYId: 2252312780,
              iRoomId: 213686,
            },
            tPresenter: {
              lPid: 2251035523,
              sNickName: '98-海天盛筵',
              sLogoUrl: 'https://huyaimg.msstatic.com/avatar/1004/d5/a3f80cb0d8469af22d30876c4084e4_180_135.jpg?1558386497',
              sPortait: 'http://livewebbs2.msstatic.com/201912guying.png',
              sBriefText: '主播简介....',
            },
            iRank: 7,
            lScore: 645370,
          },
          {
            tJump: {
              lPid: 474921909,
              lTid: 1446388354,
              lSid: 1446388354,
              iGameId: 4079,
              lYYId: 1584102,
              iRoomId: 17916648,
            },
            tPresenter: {
              lPid: 474921909,
              sNickName: '仙女-倾国倾城',
              sLogoUrl: 'https://huyaimg.msstatic.com/avatar/1067/60/418535334bd9b1213090f8c8c8e0cf_180_135.jpg?1573111870',
              sPortait: 'http://livewebbs2.msstatic.com/201912guying.png',
              sBriefText: '主播简介....',
            },
            iRank: 8,
            lScore: 604965,
          },
          {
            tJump: {
              lPid: 1199526397904,
              lTid: 1199526397904,
              lSid: 1199526397904,
              iGameId: 4079,
              lYYId: 35184432630979,
              iRoomId: 20450418,
            },
            tPresenter: {
              lPid: 1199526397904,
              sNickName: 'Dae-一晌贪欢',
              sLogoUrl: 'https://huyaimg.msstatic.com/avatar/1059/7f/5d30bc8c2b782ad9cd56a152602ac8_180_135.jpg?1575726472',
              sPortait: 'http://livewebbs2.msstatic.com/201912guying.png',
              sBriefText: '主播简介....',
            },
            iRank: 9,
            lScore: 565928,
          },
          {
            tJump: {
              lPid: 2305382498,
              lTid: 1446159505,
              lSid: 1446159505,
              iGameId: 4079,
              lYYId: 2305550865,
              iRoomId: 17760935,
            },
            tPresenter: {
              lPid: 2305382498,
              sNickName: '98-你的故事',
              sLogoUrl: 'https://huyaimg.msstatic.com/avatar/1059/88/bb6877faa6b390ae73aafc91faab72_180_135.jpg?1576044016',
              sPortait: 'http://livewebbs2.msstatic.com/201912guying.png',
              sBriefText: '主播简介....',
            },
            iRank: 10,
            lScore: 527615,
          },
          {
            tJump: {
              lPid: 1199523665911,
              lTid: 1199523665911,
              lSid: 1199523665911,
              iGameId: 4079,
              lYYId: 35184418820029,
              iRoomId: 20013649,
            },
            tPresenter: {
              lPid: 1199523665911,
              sNickName: 'Dae-勿忘初心',
              sLogoUrl: 'https://huyaimg.msstatic.com/avatar/1099/33/1205fde5a8fc5809e3167a6bf057cb_180_135.jpg?1576485334',
              sPortait: 'http://livewebbs2.msstatic.com/201912guying.png',
              sBriefText: '主播简介....',
            },
            iRank: 11,
            lScore: 513157,
          },
          {
            tJump: {
              lPid: 2490077108,
              lTid: 0,
              lSid: 0,
              iGameId: 0,
              lYYId: 35184426043647,
              iRoomId: 531427,
            },
            tPresenter: {
              lPid: 2490077108,
              sNickName: '欢c-花開十方',
              sLogoUrl: 'https://huyaimg.msstatic.com/avatar/1057/08/868255753d72ccaf26deb134240eba_180_135.jpg?1573138554',
              sPortait: 'http://livewebbs2.msstatic.com/201912guying.png',
              sBriefText: '主播简介....',
            },
            iRank: 12,
            lScore: 439373,
          },
          {
            tJump: {
              lPid: 1199520503321,
              lTid: 1199520503321,
              lSid: 1199520503321,
              iGameId: 4079,
              lYYId: 35184401380630,
              iRoomId: 19523305,
            },
            tPresenter: {
              lPid: 1199520503321,
              sNickName: '水月-甜蜜暴击',
              sLogoUrl: 'https://huyaimg.msstatic.com/avatar/1042/13/2bebaff3d944a7f93c0ea401745b9c_180_135.jpg?1570810897',
              sPortait: 'http://livewebbs2.msstatic.com/201912guying.png',
              sBriefText: '主播简介....',
            },
            iRank: 13,
            lScore: 347219,
          },
          {
            tJump: {
              lPid: 1199517349201,
              lTid: 1199517349201,
              lSid: 1199517349201,
              iGameId: 4079,
              lYYId: 35184383081873,
              iRoomId: 557143,
            },
            tPresenter: {
              lPid: 1199517349201,
              sNickName: '蓝云-青丘狐',
              sLogoUrl: 'https://huyaimg.msstatic.com/avatar/1032/67/d5c5402b4a951bb99b938375a8d008_180_135.jpg?1573628322',
              sPortait: 'http://livewebbs2.msstatic.com/201912guying.png',
              sBriefText: '主播简介....',
            },
            iRank: 14,
            lScore: 338025,
          },
          {
            tJump: {
              lPid: 2478792525,
              lTid: 1448464251,
              lSid: 1448464251,
              iGameId: 4079,
              lYYId: 35184413038181,
              iRoomId: 19834228,
            },
            tPresenter: {
              lPid: 2478792525,
              sNickName: '筑梦-不知所措',
              sLogoUrl: 'https://huyaimg.msstatic.com/avatar/1009/df/30805e22eb1c7c6a90c1535a12f026_180_135.jpg?1575134682',
              sPortait: 'http://livewebbs2.msstatic.com/201912guying.png',
              sBriefText: '主播简介....',
            },
            iRank: 15,
            lScore: 332105,
          },
          {
            tJump: {
              lPid: 2353458257,
              lTid: 1445408435,
              lSid: 1445408435,
              iGameId: 4079,
              lYYId: 2355244024,
              iRoomId: 17286024,
            },
            tPresenter: {
              lPid: 2353458257,
              sNickName: '【娱加】雨露均沾',
              sLogoUrl: 'https://huyaimg.msstatic.com/avatar/1092/8c/860bcc7fb48b8393160ff7ed3c8327_180_135.jpg?1564916239',
              sPortait: 'http://livewebbs2.msstatic.com/201912guying.png',
              sBriefText: '主播简介....',
            },
            iRank: 16,
            lScore: 305097,
          },
          {
            tJump: {
              lPid: 998441753,
              lTid: 32315043,
              lSid: 32315043,
              iGameId: 4079,
              lYYId: 965445216,
              iRoomId: 10760065,
            },
            tPresenter: {
              lPid: 998441753,
              sNickName: '筑梦-吞吞吐吐',
              sLogoUrl: 'https://huyaimg.msstatic.com/avatar/1017/4d/0d6518223f753af3ffc756fe760548_180_135.jpg?1569250489',
              sPortait: 'http://livewebbs2.msstatic.com/201912guying.png',
              sBriefText: '主播简介....',
            },
            iRank: 17,
            lScore: 358881,
          },
          {
            tJump: {
              lPid: 2294261685,
              lTid: 1444150431,
              lSid: 1444150431,
              iGameId: 4079,
              lYYId: 2294202055,
              iRoomId: 944609,
            },
            tPresenter: {
              lPid: 2294261685,
              sNickName: '蓝云-以爱之名',
              sLogoUrl: 'https://huyaimg.msstatic.com/avatar/1005/c5/49fb95a94ce7c72f19d16141a80dad_180_135.jpg?1562684233',
              sPortait: 'http://livewebbs2.msstatic.com/201912guying.png',
              sBriefText: '主播简介....',
            },
            iRank: 18,
            lScore: 345784,
          },
          {
            tJump: {
              lPid: 1199525317480,
              lTid: 1199525317480,
              lSid: 1199525317480,
              iGameId: 4079,
              lYYId: 35184427568020,
              iRoomId: 20238422,
            },
            tPresenter: {
              lPid: 1199525317480,
              sNickName: '【三思】超人女友',
              sLogoUrl: 'https://huyaimg.msstatic.com/avatar/1000/63/e28e80a8c7d8fd5c6ce3e20eb1502b_180_135.jpg?1576527094',
              sPortait: 'http://livewebbs2.msstatic.com/201912guying.png',
              sBriefText: '主播简介....',
            },
            iRank: 19,
            lScore: 337657,
          },
          {
            tJump: {
              lPid: 2391730734,
              lTid: 1446926249,
              lSid: 1446926249,
              iGameId: 4079,
              lYYId: 2393597341,
              iRoomId: 18345029,
            },
            tPresenter: {
              lPid: 2391730734,
              sNickName: 'Dae-日久生情',
              sLogoUrl: 'https://huyaimg.msstatic.com/avatar/1070/e6/917b2e84c7a0a522d37fcd02b49d57_180_135.jpg?1574734902',
              sPortait: 'http://livewebbs2.msstatic.com/201912guying.png',
              sBriefText: '主播简介....',
            },
            iRank: 20,
            lScore: 311958,
          },
          {
            tJump: {
              lPid: 2377651480,
              lTid: 1446371304,
              lSid: 1446371304,
              iGameId: 4079,
              lYYId: 2379342349,
              iRoomId: 17902261,
            },
            tPresenter: {
              lPid: 2377651480,
              sNickName: '98-晨锁未央',
              sLogoUrl: 'https://huyaimg.msstatic.com/avatar/1024/da/4032cfabe35cb9f7dd9f7aa498b561_180_135.jpg?1576404068',
              sPortait: 'http://livewebbs2.msstatic.com/201912guying.png',
              sBriefText: '主播简介....',
            },
            iRank: 21,
            lScore: 254889,
          },
          {
            tJump: {
              lPid: 1333018208,
              lTid: 1334376647,
              lSid: 1334376647,
              iGameId: 4079,
              lYYId: 1470026352,
              iRoomId: 17497319,
            },
            tPresenter: {
              lPid: 1333018208,
              sNickName: '化蝶-破茧成蝶',
              sLogoUrl: 'https://huyaimg.msstatic.com/avatar/1096/e1/5ddf0dc4f50a5ce0d8151480ae41ad_180_135.jpg?1573590314',
              sPortait: 'http://livewebbs2.msstatic.com/201912guying.png',
              sBriefText: '主播简介....',
            },
            iRank: 22,
            lScore: 245549,
          },
          {
            tJump: {
              lPid: 600834796,
              lTid: 30441528,
              lSid: 30441528,
              iGameId: 4079,
              lYYId: 527014743,
              iRoomId: 16762706,
            },
            tPresenter: {
              lPid: 600834796,
              sNickName: '演员-非常完美',
              sLogoUrl: 'https://huyaimg.msstatic.com/avatar/1039/b2/f7a27be6dec5ca5c36fc1f5a71eec5_180_135.jpg?1576483316',
              sPortait: 'http://livewebbs2.msstatic.com/201912guying.png',
              sBriefText: '主播简介....',
            },
            iRank: 23,
            lScore: 238959,
          },
          {
            tJump: {
              lPid: 950085115,
              lTid: 1446837976,
              lSid: 1446837976,
              iGameId: 4079,
              lYYId: 915322612,
              iRoomId: 273698,
            },
            tPresenter: {
              lPid: 950085115,
              sNickName: '98-爱吹牛B',
              sLogoUrl: 'https://huyaimg.msstatic.com/avatar/1041/ca/f2485a3f68cd5736fac5f879a9789e_180_135.jpg?1554195621',
              sPortait: 'http://livewebbs2.msstatic.com/201912guying.png',
              sBriefText: '主播简介....',
            },
            iRank: 24,
            lScore: 236970,
          },
          {
            tJump: {
              lPid: 1199526144715,
              lTid: 1199526144715,
              lSid: 1199526144715,
              iGameId: 4079,
              lYYId: 35184431380929,
              iRoomId: 20393387,
            },
            tPresenter: {
              lPid: 1199526144715,
              sNickName: 'Xx-前女友',
              sLogoUrl: 'https://huyaimg.msstatic.com/avatar/1022/b4/702b26e0276083af63d5a61e174551_180_135.jpg?1575601590',
              sPortait: 'http://livewebbs2.msstatic.com/201912guying.png',
              sBriefText: '主播简介....',
            },
            iRank: 25,
            lScore: 230228,
          },
          {
            tJump: {
              lPid: 1259512604561,
              lTid: 1259512604561,
              lSid: 1259512604561,
              iGameId: 4079,
              lYYId: 35184382443850,
              iRoomId: 19856642,
            },
            tPresenter: {
              lPid: 1259512604561,
              sNickName: 'toz-玩乐',
              sLogoUrl: 'https://huyaimg.msstatic.com/avatar/1051/9a/8c9cb900b3ad4371488985b630daeb_180_135.jpg?1570515142',
              sPortait: 'http://livewebbs2.msstatic.com/201912guying.png',
              sBriefText: '主播简介....',
            },
            iRank: 26,
            lScore: 205773,
          },
          {
            tJump: {
              lPid: 1279516121755,
              lTid: 0,
              lSid: 0,
              iGameId: 0,
              lYYId: 35184400150630,
              iRoomId: 19986183,
            },
            tPresenter: {
              lPid: 1279516121755,
              sNickName: '欢c-糖果屋',
              sLogoUrl: 'https://huyaimg.msstatic.com/avatar/1066/91/f30764ca037140faec22cce7d83ac6_180_135.jpg?1575768402',
              sPortait: 'http://livewebbs2.msstatic.com/201912guying.png',
              sBriefText: '主播简介....',
            },
            iRank: 27,
            lScore: 199599,
          },
          {
            tJump: {
              lPid: 1199516542702,
              lTid: 1199516542702,
              lSid: 1199516542702,
              iGameId: 4079,
              lYYId: 35184381027372,
              iRoomId: 331428,
            },
            tPresenter: {
              lPid: 1199516542702,
              sNickName: '血色-战神归来',
              sLogoUrl: 'https://huyaimg.msstatic.com/avatar/1096/78/537d8d5d7a1eab20059bfe34d96e44_180_135.jpg?1573315111',
              sPortait: 'http://livewebbs2.msstatic.com/201912guying.png',
              sBriefText: '主播简介....',
            },
            iRank: 28,
            lScore: 168145,
          },
          {
            tJump: {
              lPid: 1066522234,
              lTid: 73800923,
              lSid: 73800923,
              iGameId: 4079,
              lYYId: 1130808162,
              iRoomId: 17108430,
            },
            tPresenter: {
              lPid: 1066522234,
              sNickName: '化蝶-铭豪世家',
              sLogoUrl: 'https://huyaimg.msstatic.com/avatar/1035/39/4d3f3a404ee7113c6bc47468c66a0c_180_135.jpg?1573542011',
              sPortait: 'http://livewebbs2.msstatic.com/201912guying.png',
              sBriefText: '主播简介....',
            },
            iRank: 29,
            lScore: 156133,
          },
          {
            tJump: {
              lPid: 1199514549382,
              lTid: 1199514549382,
              lSid: 1199514549382,
              iGameId: 4079,
              lYYId: 35184378803938,
              iRoomId: 18272968,
            },
            tPresenter: {
              lPid: 1199514549382,
              sNickName: '血色-约会现场',
              sLogoUrl: 'https://huyaimg.msstatic.com/avatar/1002/eb/9766e2599af08753708f68f7a1aa59_180_135.jpg?1576475501',
              sPortait: 'http://livewebbs2.msstatic.com/201912guying.png',
              sBriefText: '主播简介....',
            },
            iRank: 30,
            lScore: 154042,
          },
          {
            tJump: {
              lPid: 1199523098062,
              lTid: 0,
              lSid: 0,
              iGameId: 0,
              lYYId: 35184414841324,
              iRoomId: 19897503,
            },
            tPresenter: {
              lPid: 1199523098062,
              sNickName: 'Hz-蜜桃少女',
              sLogoUrl: 'https://huyaimg.msstatic.com/avatar/1082/3b/59162a4080a44540791afda3d2c272_180_135.jpg?1575521260',
              sPortait: 'http://livewebbs2.msstatic.com/201912guying.png',
              sBriefText: '主播简介....',
            },
            iRank: 31,
            lScore: 130858,
          },
          {
            tJump: {
              lPid: 1199521840646,
              lTid: 1199521840646,
              lSid: 1199521840646,
              iGameId: 4079,
              lYYId: 35184407139815,
              iRoomId: 19662373,
            },
            tPresenter: {
              lPid: 1199521840646,
              sNickName: 'Hz-上善若水',
              sLogoUrl: 'https://huyaimg.msstatic.com/avatar/1065/09/b5771b79c92f7f3985f80553193793_180_135.jpg?1567966327',
              sPortait: 'http://livewebbs2.msstatic.com/201912guying.png',
              sBriefText: '主播简介....',
            },
            iRank: 32,
            lScore: 130810,
          },
          {
            tJump: {
              lPid: 1199524877471,
              lTid: 1199524877471,
              lSid: 1199524877471,
              iGameId: 4079,
              lYYId: 35184425655442,
              iRoomId: 20191955,
            },
            tPresenter: {
              lPid: 1199524877471,
              sNickName: 'Dae-深入浅出',
              sLogoUrl: 'https://huyaimg.msstatic.com/avatar/1090/3a/3eef602040035018544932230b95f7_180_135.jpg?1572701790',
              sPortait: 'http://livewebbs2.msstatic.com/201912guying.png',
              sBriefText: '主播简介....',
            },
            iRank: 33,
            lScore: 150566,
          },
          {
            tJump: {
              lPid: 113133319,
              lTid: 1446982048,
              lSid: 1446982048,
              iGameId: 4079,
              lYYId: 89121072,
              iRoomId: 18408623,
            },
            tPresenter: {
              lPid: 113133319,
              sNickName: '血色-锦绣江山',
              sLogoUrl: 'https://huyaimg.msstatic.com/avatar/1029/63/5d81da5f966d6d4a4b01537035b906_180_135.jpg?1570525915',
              sPortait: 'http://livewebbs2.msstatic.com/201912guying.png',
              sBriefText: '主播简介....',
            },
            iRank: 34,
            lScore: 149079,
          },
          {
            tJump: {
              lPid: 1199524427114,
              lTid: 1199524427114,
              lSid: 1199524427114,
              iGameId: 4079,
              lYYId: 35184422542511,
              iRoomId: 20113224,
            },
            tPresenter: {
              lPid: 1199524427114,
              sNickName: 'Dae-群星',
              sLogoUrl: 'https://huyaimg.msstatic.com/avatar/1046/97/f722ebe001e07edae2a109c708f7d4_180_135.jpg?1571844320',
              sPortait: 'http://livewebbs2.msstatic.com/201912guying.png',
              sBriefText: '主播简介....',
            },
            iRank: 35,
            lScore: 149076,
          },
          {
            tJump: {
              lPid: 1279516282267,
              lTid: 1279516282267,
              lSid: 1279516282267,
              iGameId: 4079,
              lYYId: 35184401297389,
              iRoomId: 19988728,
            },
            tPresenter: {
              lPid: 1279516282267,
              sNickName: '【新娱加】一拍即合',
              sLogoUrl: 'https://huyaimg.msstatic.com/avatar/1058/d6/0e0faa4ef7af3093b797b3e23f0c65_180_135.jpg?1576473786',
              sPortait: 'http://livewebbs2.msstatic.com/201912guying.png',
              sBriefText: '主播简介....',
            },
            iRank: 36,
            lScore: 148540,
          },
          {
            tJump: {
              lPid: 2323870146,
              lTid: 1444135841,
              lSid: 1444135841,
              iGameId: 4079,
              lYYId: 2325943670,
              iRoomId: 16534227,
            },
            tPresenter: {
              lPid: 2323870146,
              sNickName: '98-承蒙不弃',
              sLogoUrl: 'https://huyaimg.msstatic.com/avatar/1027/1c/d1e33cf153e57cbe2ea9ab7805fc9a_180_135.jpg?1576400955',
              sPortait: 'http://livewebbs2.msstatic.com/201912guying.png',
              sBriefText: '主播简介....',
            },
            iRank: 37,
            lScore: 122346,
          },
          {
            tJump: {
              lPid: 1370226216,
              lTid: 1448474892,
              lSid: 1448474892,
              iGameId: 4079,
              lYYId: 1517323719,
              iRoomId: 19845955,
            },
            tPresenter: {
              lPid: 1370226216,
              sNickName: 'Dae-唇诱',
              sLogoUrl: 'https://huyaimg.msstatic.com/avatar/1085/b2/f3fbd8da6ad558e538c4a1952f56b7_180_135.jpg?1574596046',
              sPortait: 'http://livewebbs2.msstatic.com/201912guying.png',
              sBriefText: '主播简介....',
            },
            iRank: 38,
            lScore: 120457,
          },
          {
            tJump: {
              lPid: 2281644290,
              lTid: 1448548817,
              lSid: 1448548817,
              iGameId: 4079,
              lYYId: 35184414618715,
              iRoomId: 19918189,
            },
            tPresenter: {
              lPid: 2281644290,
              sNickName: '仙女-一笑倾城',
              sLogoUrl: 'https://huyaimg.msstatic.com/avatar/1051/dd/33a63f14d2261f794b4cfac3d648a6_180_135.jpg?1573032412',
              sPortait: 'http://livewebbs2.msstatic.com/201912guying.png',
              sBriefText: '主播简介....',
            },
            iRank: 39,
            lScore: 116473,
          },
          {
            tJump: {
              lPid: 1199526177798,
              lTid: 0,
              lSid: 0,
              iGameId: 0,
              lYYId: 35184431573185,
              iRoomId: 20402362,
            },
            tPresenter: {
              lPid: 1199526177798,
              sNickName: '天皓-一周七日',
              sLogoUrl: 'https://huyaimg.msstatic.com/avatar/1078/90/3ba6e8cbdc3ae3c9ea2e2192f8583a_180_135.jpg?1575125751',
              sPortait: 'http://livewebbs2.msstatic.com/201912guying.png',
              sBriefText: '主播简介....',
            },
            iRank: 40,
            lScore: 115880,
          },
          {
            tJump: {
              lPid: 1199518983353,
              lTid: 1199518983353,
              lSid: 1199518983353,
              iGameId: 4079,
              lYYId: 35184393923751,
              iRoomId: 19462789,
            },
            tPresenter: {
              lPid: 1199518983353,
              sNickName: '98-需要人陪',
              sLogoUrl: 'https://huyaimg.msstatic.com/avatar/1021/bd/f20e1e2d9701e10f0844f43cff83ba_180_135.jpg?1566744869',
              sPortait: 'http://livewebbs2.msstatic.com/201912guying.png',
              sBriefText: '主播简介....',
            },
            iRank: 41,
            lScore: 115246,
          },
          {
            tJump: {
              lPid: 1199523531397,
              lTid: 1199523531397,
              lSid: 1199523531397,
              iGameId: 4079,
              lYYId: 35184417747314,
              iRoomId: 19980677,
            },
            tPresenter: {
              lPid: 1199523531397,
              sNickName: 'Hz-恋爱物语',
              sLogoUrl: 'https://huyaimg.msstatic.com/avatar/1045/b9/574099691d47a6d0556d8e3716fa81_180_135.jpg?1576568759',
              sPortait: 'http://livewebbs2.msstatic.com/201912guying.png',
              sBriefText: '主播简介....',
            },
            iRank: 42,
            lScore: 114325,
          },
          {
            tJump: {
              lPid: 1199524178735,
              lTid: 0,
              lSid: 0,
              iGameId: 0,
              lYYId: 35184420618687,
              iRoomId: 20071815,
            },
            tPresenter: {
              lPid: 1199524178735,
              sNickName: 'Rio-一夜春宵',
              sLogoUrl: 'https://huyaimg.msstatic.com/avatar/1068/d1/115accce1e37a24014d590ee2f1c28_180_135.jpg?1573142958',
              sPortait: 'http://livewebbs2.msstatic.com/201912guying.png',
              sBriefText: '主播简介....',
            },
            iRank: 43,
            lScore: 112720,
          },
          {
            tJump: {
              lPid: 2360378086,
              lTid: 1445726878,
              lSid: 1445726878,
              iGameId: 4079,
              lYYId: 2362376289,
              iRoomId: 17486580,
            },
            tPresenter: {
              lPid: 2360378086,
              sNickName: '蓝云-七情六欲',
              sLogoUrl: 'https://huyaimg.msstatic.com/avatar/1074/f1/5783a90f6557e70b897d386aa9276d_180_135.jpg?1576455022',
              sPortait: 'http://livewebbs2.msstatic.com/201912guying.png',
              sBriefText: '主播简介....',
            },
            iRank: 44,
            lScore: 112381,
          },
          {
            tJump: {
              lPid: 2456385692,
              lTid: 1448318974,
              lSid: 1448318974,
              iGameId: 4079,
              lYYId: 2408142554,
              iRoomId: 19609316,
            },
            tPresenter: {
              lPid: 2456385692,
              sNickName: 'DY-上帝的宠儿',
              sLogoUrl: 'https://huyaimg.msstatic.com/avatar/1031/1d/b1e33edaa752cf75f1b2e542712703_180_135.jpg?1574414100',
              sPortait: 'http://livewebbs2.msstatic.com/201912guying.png',
              sBriefText: '主播简介....',
            },
            iRank: 45,
            lScore: 112125,
          },
          {
            tJump: {
              lPid: 1199524388956,
              lTid: 0,
              lSid: 0,
              iGameId: 0,
              lYYId: 35184422468691,
              iRoomId: 188531,
            },
            tPresenter: {
              lPid: 1199524388956,
              sNickName: '清风【退】',
              sLogoUrl: 'https://huyaimg.msstatic.com/avatar/1085/45/efda962ca927e61025831e71f9a991_180_135.jpg?1576159643',
              sPortait: 'http://livewebbs2.msstatic.com/201912guying.png',
              sBriefText: '主播简介....',
            },
            iRank: 46,
            lScore: 110717,
          },
          {
            tJump: {
              lPid: 1259513307019,
              lTid: 1259513307019,
              lSid: 1259513307019,
              iGameId: 4079,
              lYYId: 35184384208193,
              iRoomId: 19150211,
            },
            tPresenter: {
              lPid: 1259513307019,
              sNickName: '心大-天上人间',
              sLogoUrl: 'https://huyaimg.msstatic.com/avatar/1086/b9/3572e5e6f423c4849f3153b93d639a_180_135.jpg?1573373669',
              sPortait: 'http://livewebbs2.msstatic.com/201912guying.png',
              sBriefText: '主播简介....',
            },
            iRank: 47,
            lScore: 102448,
          },
          {
            tJump: {
              lPid: 1199523678083,
              lTid: 0,
              lSid: 0,
              iGameId: 0,
              lYYId: 35184418787485,
              iRoomId: 20014638,
            },
            tPresenter: {
              lPid: 1199523678083,
              sNickName: 'Dae-迷惑行为',
              sLogoUrl: 'https://huyaimg.msstatic.com/avatar/1016/45/ac2943959f8102232b857c59dd759c_180_135.jpg?1575228403',
              sPortait: 'http://livewebbs2.msstatic.com/201912guying.png',
              sBriefText: '主播简介....',
            },
            iRank: 48,
            lScore: 100225,
          },
          {
            tJump: {
              lPid: 946052606,
              lTid: 1448529037,
              lSid: 1448529037,
              iGameId: 4079,
              lYYId: 35184414042715,
              iRoomId: 19873006,
            },
            tPresenter: {
              lPid: 946052606,
              sNickName: 'Top-恋爱',
              sLogoUrl: 'https://huyaimg.msstatic.com/avatar/1047/9c/24b77bfff9be248e362bf2e17b1242_180_135.jpg?1574700341',
              sPortait: 'http://livewebbs2.msstatic.com/201912guying.png',
              sBriefText: '主播简介....',
            },
            iRank: 49,
            lScore: 98417,
          },
          {
            tJump: {
              lPid: 1259520216479,
              lTid: 1259520216479,
              lSid: 1259520216479,
              iGameId: 4079,
              lYYId: 35184411763132,
              iRoomId: 19859753,
            },
            tPresenter: {
              lPid: 1259520216479,
              sNickName: 'JJ-万神宠爱',
              sLogoUrl: 'https://huyaimg.msstatic.com/avatar/1000/b1/4a2e82c19376a8476107c3529785d3_180_135.jpg?1569487799',
              sPortait: 'http://livewebbs2.msstatic.com/201912guying.png',
              sBriefText: '主播简介....',
            },
            iRank: 50,
            lScore: 96336,
          },
        ],
      },
      iStage: 5,
      iArea: 3,
      sStageTips: '2019年度交友新势力主播已经诞生，恭喜以下获奖主播',
    },
    richRank: {
      vRankList: {
        proto: {
          lUid: 0,
          iRank: 0,
          lScore: 0,
          sNickName: '',
          sLogoUrl: '',
          iLabel: 0,
        },
        value: [
          {
            lUid: 1700846846,
            iRank: 1,
            lScore: 27027898,
            sNickName: '君子固穷【烟雨楼】退',
            sLogoUrl: 'https://huyaimg.msstatic.com/avatar/1074/42/cc2a25c380c9519be6f4d34ffe4457_180_135.jpg?1536705529',
            iLabel: 1,
          },
          {
            lUid: 1279522456417,
            iRank: 2,
            lScore: 19016746,
            sNickName: '浩会计',
            sLogoUrl: 'https://huyaimg.msstatic.com/avatar/1098/f5/a928e50689c7ec5e3ad9923e616fab_180_135.jpg?1576244940',
            iLabel: 1,
          },
          {
            lUid: 1420556422,
            iRank: 3,
            lScore: 11095559,
            sNickName: '糕会计',
            sLogoUrl: 'https://huyaimg.msstatic.com/avatar/1056/19/d3a8caefcf6599a4dbd78617113cc7_180_135.jpg?1576520144',
            iLabel: 1,
          },
          {
            lUid: 2456700337,
            iRank: 4,
            lScore: 6666233,
            sNickName: '陈冠希',
            sLogoUrl: 'https://huyaimg.msstatic.com/avatar/1031/a9/7780fe40a4ff0aff504511a87a8256_180_135.jpg?1564907659',
            iLabel: 0,
          },
          {
            lUid: 2304844074,
            iRank: 5,
            lScore: 4746663,
            sNickName: '白衣染霜华【烟雨楼】退',
            sLogoUrl: 'https://huyaimg.msstatic.com/avatar/1025/1d/e5c41ee92d3ee9589c5d5704afc1d2_180_135.jpg?1544733450',
            iLabel: 0,
          },
          {
            lUid: 1199516957576,
            iRank: 6,
            lScore: 3983260,
            sNickName: '关注江澜12月30周年庆',
            sLogoUrl: 'https://huyaimg.msstatic.com/avatar/1039/17/8d6dbfa4e2a7a0136167ed76c6a69b_180_135.jpg?1575003216',
            iLabel: 0,
          },
          {
            lUid: 1279514286366,
            iRank: 7,
            lScore: 3809559,
            sNickName: '宁不换右客',
            sLogoUrl: 'https://huyaimg.msstatic.com/avatar/1035/08/dfe87d679c7528dabe0b29dc32baf2_180_135.jpg?1568589211',
            iLabel: 0,
          },
          {
            lUid: 1171141445,
            iRank: 8,
            lScore: 3694351,
            sNickName: '再饮吞日月',
            sLogoUrl: 'https://huyaimg.msstatic.com/avatar/1018/62/3c7da30c83e3be65478f8729312b06_180_135.jpg?1574831618',
            iLabel: 0,
          },
          {
            lUid: 1199526573676,
            iRank: 9,
            lScore: 3416023,
            sNickName: '乔会计【尾生】',
            sLogoUrl: 'https://huyaimg.msstatic.com/avatar/1032/ef/df168cd027ad4980190e6ce06613d7_180_135.jpg?1576059751',
            iLabel: 0,
          },
          {
            lUid: 1372670455,
            iRank: 10,
            lScore: 3278270,
            sNickName: '奕',
            sLogoUrl: 'https://huyaimg.msstatic.com/avatar/1019/10/4048796a8e6de1749c8265723fb5e2_180_135.jpg?1576617145',
            iLabel: 0,
          },
          {
            lUid: 2234100134,
            iRank: 11,
            lScore: 3140379,
            sNickName: 'Dae-羽言',
            sLogoUrl: 'https://huyaimg.msstatic.com/avatar/1022/e5/20fce5fd0bd006f71d9fbb66567c2c_180_135.jpg?1542370703',
            iLabel: 0,
          },
          {
            lUid: 2249817109,
            iRank: 12,
            lScore: 2681972,
            sNickName: '图图【精神股东】场控',
            sLogoUrl: 'https://huyaimg.msstatic.com/avatar/1005/62/fb939195a64a2869719d1abeff28f3_180_135.jpg?1548138575',
            iLabel: 0,
          },
          {
            lUid: 1799630964,
            iRank: 13,
            lScore: 2226840,
            sNickName: '【Dae傲诗】战为大鹅',
            sLogoUrl: 'https://huyaimg.msstatic.com/avatar/1026/82/43c2a90a2055f7b97a1c19a59246ec_180_135.jpg?1539252030',
            iLabel: 0,
          },
          {
            lUid: 1199522925412,
            iRank: 14,
            lScore: 2157277,
            sNickName: '亲亲妹妹',
            sLogoUrl: 'https://huyaimg.msstatic.com/avatar/1002/8c/a3c8eff81bf81c598ee0d1f18899ba_180_135.jpg?1576307989',
            iLabel: 0,
          },
          {
            lUid: 2209230530,
            iRank: 15,
            lScore: 2134560,
            sNickName: '【Dae沈易】战为大鹅',
            sLogoUrl: 'https://huyaimg.msstatic.com/avatar/1048/b1/fb3847fa55a7630660f1929f38b64e_180_135.jpg?1576319271',
            iLabel: 0,
          },
          {
            lUid: 2456611446,
            iRank: 16,
            lScore: 2134440,
            sNickName: '快乐风男',
            sLogoUrl: 'https://huyaimg.msstatic.com/avatar/1008/5e/07444775e4329068f105780779ed7f_180_135.jpg?1576508792',
            iLabel: 0,
          },
          {
            lUid: 2456700356,
            iRank: 17,
            lScore: 2122748,
            sNickName: '路边跟',
            sLogoUrl: 'https://huyaimg.msstatic.com/avatar/1045/20/37e95b570e1e8ba7b0949506967406_180_135.jpg?1576468901',
            iLabel: 0,
          },
          {
            lUid: 2456611312,
            iRank: 18,
            lScore: 2064650,
            sNickName: '叶梓汐【陨】',
            sLogoUrl: 'https://huyaimg.msstatic.com/avatar/1026/c2/90422e83214b0f622a5607094fedb3_180_135.jpg?1576094551',
            iLabel: 0,
          },
          {
            lUid: 427621200,
            iRank: 19,
            lScore: 2045799,
            sNickName: '地主仔【007】退',
            sLogoUrl: 'https://huyaimg.msstatic.com/avatar/1074/d1/500d291c4a0144518504289fb9fcac_180_135.jpg?1573575984',
            iLabel: 0,
          },
          {
            lUid: 2252598740,
            iRank: 20,
            lScore: 1978525,
            sNickName: '若鸿',
            sLogoUrl: 'https://huyaimg.msstatic.com/avatar/1056/cb/d27b006d40376225bad5a915fc89d1_180_135.jpg?1567089397',
            iLabel: 0,
          },
          {
            lUid: 1259522486935,
            iRank: 21,
            lScore: 1954654,
            sNickName: '血色-小狐狸【时间】',
            sLogoUrl: 'https://huyaimg.msstatic.com/avatar/1041/f0/3c7311559d1e3309e9371a19a14616_180_135.jpg?1573366772',
            iLabel: 0,
          },
          {
            lUid: 1706072103,
            iRank: 22,
            lScore: 1782020,
            sNickName: '集梦会长',
            sLogoUrl: 'https://huyaimg.msstatic.com/avatar/1040/f6/2d1440b6b9108823c8fd370a3720e3_180_135.jpg?1539839211',
            iLabel: 0,
          },
          {
            lUid: 1199517636356,
            iRank: 23,
            lScore: 1717238,
            sNickName: '海王HW-【小慧盼糕归】',
            sLogoUrl: 'https://huyaimg.msstatic.com/avatar/1047/81/51a07c655d079a88db6e8bfe644ea6_180_135.jpg?1575046140',
            iLabel: 0,
          },
          {
            lUid: 2250421007,
            iRank: 24,
            lScore: 1667710,
            sNickName: '国民爸爸【退】',
            sLogoUrl: 'https://huyaimg.msstatic.com/avatar/1042/cd/6aff60e2be046678c353dcf1f802f8_180_135.jpg?1573285242',
            iLabel: 0,
          },
          {
            lUid: 2479568719,
            iRank: 25,
            lScore: 1618980,
            sNickName: '伊泽瑞尔',
            sLogoUrl: 'https://huyaimg.msstatic.com/avatar/1070/2a/c7c02504b327ce4de444857e00af9e_180_135.jpg?1576481514',
            iLabel: 0,
          },
          {
            lUid: 1199517245382,
            iRank: 26,
            lScore: 1606819,
            sNickName: '大事件、敬漫',
            sLogoUrl: 'https://huyaimg.msstatic.com/avatar/1088/b3/76358ff6766dde16cb8f6e6725e812_180_135.jpg?1561621836',
            iLabel: 0,
          },
          {
            lUid: 2177582549,
            iRank: 27,
            lScore: 1521543,
            sNickName: '毅99',
            sLogoUrl: 'https://huyaimg.msstatic.com/avatar/1044/98/7ac6c2469c05a27b291e0cdc886e99_180_135.jpg?1576630254',
            iLabel: 0,
          },
          {
            lUid: 1199517579715,
            iRank: 28,
            lScore: 1392658,
            sNickName: '体面的昏晓【006】',
            sLogoUrl: '',
            iLabel: 0,
          },
          {
            lUid: 2196324330,
            iRank: 29,
            lScore: 1359864,
            sNickName: '血色卡拉xsnh9135',
            sLogoUrl: 'https://huyaimg.msstatic.com/avatar/1075/de/dcadf3e931566ed23a6284050d95c8_180_135.jpg?1540270933',
            iLabel: 0,
          },
          {
            lUid: 1484743214,
            iRank: 30,
            lScore: 1272387,
            sNickName: '旺仔牛奶【游灯会】',
            sLogoUrl: 'https://huyaimg.msstatic.com/avatar/1092/f1/9f0d43cfc7dd56a97cc326b62026d2_180_135.jpg?1576133359',
            iLabel: 0,
          },
          {
            lUid: 1259512665153,
            iRank: 31,
            lScore: 1209654,
            sNickName: '万径人踪灭',
            sLogoUrl: 'https://huyaimg.msstatic.com/avatar/1051/8c/b766b34d5f86f0154c3b3455cf0d5a_180_135.jpg?1560172228',
            iLabel: 0,
          },
          {
            lUid: 2339127907,
            iRank: 32,
            lScore: 1197425,
            sNickName: 'Wave',
            sLogoUrl: 'https://huyaimg.msstatic.com/avatar/1039/da/42ca39566c5dfdc4d197c386c96934_180_135.jpg?1575359174',
            iLabel: 0,
          },
          {
            lUid: 1279512964436,
            iRank: 33,
            lScore: 1130381,
            sNickName: '依廷',
            sLogoUrl: 'https://huyaimg.msstatic.com/avatar/1048/69/e449ca007935b59e339a152e597638_180_135.jpg?1561437077',
            iLabel: 0,
          },
          {
            lUid: 1098994694,
            iRank: 34,
            lScore: 1095351,
            sNickName: '花臂小神龙【006】',
            sLogoUrl: 'https://huyaimg.msstatic.com/avatar/1087/fb/02653eb5828cb7deb99cf5a4c607e7_180_135.jpg?1562561945',
            iLabel: 0,
          },
          {
            lUid: 1687968524,
            iRank: 35,
            lScore: 1075086,
            sNickName: 'LK-轻念欧巴',
            sLogoUrl: 'http://huyaimg.msstatic.com/avatar/1093/3a/7f2514e8ccae6d1c4fa9a893cc1196_180_135.jpg?1523797174',
            iLabel: 0,
          },
          {
            lUid: 2450968078,
            iRank: 36,
            lScore: 1029785,
            sNickName: '宠会计、218',
            sLogoUrl: 'https://huyaimg.msstatic.com/avatar/1047/20/00e833cdab17b05f4a7a5ae6b4739a_180_135.jpg?1571991982',
            iLabel: 0,
          },
          {
            lUid: 2361860651,
            iRank: 37,
            lScore: 1015176,
            sNickName: '昊',
            sLogoUrl: 'https://huyaimg.msstatic.com/avatar/1006/0d/a5242c6e38c930ff50bc586da16158_180_135.jpg?1547180293',
            iLabel: 0,
          },
          {
            lUid: 2493070676,
            iRank: 38,
            lScore: 1013103,
            sNickName: '宝被-右手舞剑',
            sLogoUrl: 'https://huyaimg.msstatic.com/avatar/1082/96/2898a74b0b18f852d2cc5508c52a4d_180_135.jpg?1574331678',
            iLabel: 0,
          },
          {
            lUid: 1814254320,
            iRank: 39,
            lScore: 998804,
            sNickName: 'LH、林皮皮',
            sLogoUrl: 'https://huyaimg.msstatic.com/avatar/1044/25/475ec09d317121e056154218673861_180_135.jpg?1572725687',
            iLabel: 0,
          },
          {
            lUid: 1199524318148,
            iRank: 40,
            lScore: 998716,
            sNickName: '哦哦哦',
            sLogoUrl: 'https://huyaimg.msstatic.com/avatar/1010/26/de06ef6cc66983ab37e1d6f48cba52_180_135.jpg?1571655556',
            iLabel: 0,
          },
          {
            lUid: 2399160272,
            iRank: 41,
            lScore: 990895,
            sNickName: '陈平安',
            sLogoUrl: 'https://huyaimg.msstatic.com/avatar/1087/9e/ba20b985f252c33991e0074bc8f0b8_180_135.jpg?1574684082',
            iLabel: 0,
          },
          {
            lUid: 1765199439,
            iRank: 42,
            lScore: 899619,
            sNickName: '桜の木',
            sLogoUrl: 'https://huyaimg.msstatic.com/avatar/1005/14/af75d774ed4122e00665900d709e07_180_135.jpg?1557592429',
            iLabel: 0,
          },
          {
            lUid: 2191963198,
            iRank: 43,
            lScore: 894299,
            sNickName: '【知】远方的路【退】',
            sLogoUrl: 'http://huyaimg.msstatic.com/avatar/1068/01/b2af4f2f47772962f5d3f76c888c9c_180_135.jpg?1513194711',
            iLabel: 0,
          },
          {
            lUid: 1199512715633,
            iRank: 44,
            lScore: 869129,
            sNickName: '退',
            sLogoUrl: 'https://huyaimg.msstatic.com/avatar/1076/7d/f8d2803c60a587342278e8e9156f33_180_135.jpg?1576305066',
            iLabel: 0,
          },
          {
            lUid: 2197038785,
            iRank: 45,
            lScore: 867359,
            sNickName: '大天使LaFree',
            sLogoUrl: 'https://huyaimg.msstatic.com/avatar/1073/4e/0ed494964c47b7e6b27db12323171a_180_135.jpg?1569122725',
            iLabel: 0,
          },
          {
            lUid: 2291610870,
            iRank: 46,
            lScore: 855469,
            sNickName: '犀利强',
            sLogoUrl: 'https://huyaimg.msstatic.com/avatar/1016/7f/ae48878db7179c7c538683d1120e47_180_135.jpg?1575371052',
            iLabel: 0,
          },
          {
            lUid: 1685448432,
            iRank: 47,
            lScore: 841431,
            sNickName: '星点-4304375',
            sLogoUrl: 'https://huyaimg.msstatic.com/avatar/1094/05/346bac63fa8fc72d6d08d0a2f40820_180_135.jpg?1576519674',
            iLabel: 0,
          },
          {
            lUid: 1570768109,
            iRank: 48,
            lScore: 811940,
            sNickName: '别招我烦',
            sLogoUrl: 'https://huyaimg.msstatic.com/avatar/1026/95/54e9aac05b28b2e9dc6d842c27624b_180_135.jpg?1574570033',
            iLabel: 0,
          },
          {
            lUid: 1259512306037,
            iRank: 49,
            lScore: 782860,
            sNickName: '钢铁侠【323】',
            sLogoUrl: 'https://huyaimg.msstatic.com/avatar/1073/9f/432911b86fb331b11dbdbb68809caf_180_135.jpg?1564202824',
            iLabel: 0,
          },
          {
            lUid: 1730525047,
            iRank: 50,
            lScore: 775278,
            sNickName: '皇阿玛【MY团】',
            sLogoUrl: 'https://huyaimg.msstatic.com/avatar/1010/70/456ee20ca90f7ca337918ce0770051_180_135.jpg?1573559674',
            iLabel: 0,
          },
        ],
      },
    },
  },
  zongjuexuan: {
    youxi: {"vRank":{"proto":{"tJump":{"lPid":0,"lTid":0,"lSid":0,"iGameId":0,"lYYId":0,"iRoomId":0},"tPresenter":{"lPid":0,"sNickName":"","sLogoUrl":"","sPortait":"","sBriefText":""},"iRank":0,"lScore":0},"value":[{"tJump":{"lPid":294636272,"lTid":0,"lSid":0,"iGameId":0,"lYYId":229813522,"iRoomId":998998},"tPresenter":{"lPid":294636272,"sNickName":"狂鸟丶楚河-90327","sLogoUrl":"https://huyaimg.msstatic.com/avatar/1086/bf/fd6f69d69c0015eaface1f6024869e_180_135.jpg?1572144687","sPortait":"https://v-cms-img.huya.com/huya/201912ND/photov2/103.png","sBriefText":"单机游戏全能主播，挖掘机收藏大家"},"iRank":1,"lScore":27999098},{"tJump":{"lPid":311913984,"lTid":0,"lSid":0,"iGameId":0,"lYYId":58000,"iRoomId":10888},"tPresenter":{"lPid":311913984,"sNickName":"AzZ丶狂人","sLogoUrl":"http://huyaimg.msstatic.com/avatar/1069/a8/028a1c545ab90184f502cd7a9b1a2a_180_135.jpg","sPortait":"https://v-cms-img.huya.com/huya/201912ND/photov2/116.png","sBriefText":"DNF倒霉小王子，毁区爱好者，Flag狂魔，增幅圣手"},"iRank":2,"lScore":16724476},{"tJump":{"lPid":1539218884,"lTid":0,"lSid":0,"iGameId":0,"lYYId":464076,"iRoomId":10660},"tPresenter":{"lPid":1539218884,"sNickName":"心态【涅槃】","sLogoUrl":"https://huyaimg.msstatic.com/avatar/1064/50/31ec45ae25460bfccc5ec977ea3f65_180_135.jpg?1563088221","sPortait":"https://v-cms-img.huya.com/huya/201912ND/photov2/110.png","sBriefText":"王者国服主播，曾创造最长韩信连胜纪录"},"iRank":3,"lScore":14814954},{"tJump":{"lPid":2227875499,"lTid":0,"lSid":0,"iGameId":0,"lYYId":2228105469,"iRoomId":9986},"tPresenter":{"lPid":2227875499,"sNickName":"DK-不求人","sLogoUrl":"https://huyaimg.msstatic.com/avatar/1047/5c/4d80f4387076b0ca7ce542ed5e5884_180_135.jpg?1569520619","sPortait":"https://v-cms-img.huya.com/huya/201912ND/photov2/104.png","sBriefText":"求求部落leader，1v4战神，和平精英人气主播"},"iRank":4,"lScore":11345630},{"tJump":{"lPid":2258195946,"lTid":0,"lSid":0,"iGameId":0,"lYYId":2259315048,"iRoomId":713422},"tPresenter":{"lPid":2258195946,"sNickName":"宝子啊","sLogoUrl":"https://huyaimg.msstatic.com/avatar/1003/f5/5797f183f571105c8e31842ee077c8_180_135.jpg?1537291226","sPortait":"https://v-cms-img.huya.com/huya/201912ND/photov2/101.png","sBriefText":"长相甜美，技术出色，人称“钢枪女神”"},"iRank":5,"lScore":11103063},{"tJump":{"lPid":1205400960,"lTid":0,"lSid":0,"iGameId":0,"lYYId":1307501493,"iRoomId":520187},"tPresenter":{"lPid":1205400960,"sNickName":"正恒pop-小仔【西厂】","sLogoUrl":"https://huyaimg.msstatic.com/avatar/1073/fa/cc1854cb8525b566424270ff22865c_180_135.jpg?1575293459","sPortait":"https://v-cms-img.huya.com/huya/201912ND/photov2/106.png","sBriefText":"十三枪创始人，全网第一情感导师"},"iRank":6,"lScore":10596469},{"tJump":{"lPid":1861606916,"lTid":1340891384,"lSid":1340891384,"iGameId":3203,"lYYId":2114243903,"iRoomId":52503},"tPresenter":{"lPid":1861606916,"sNickName":"Dae-柔柔【犯二柔】","sLogoUrl":"https://huyaimg.msstatic.com/avatar/1093/71/842158752460e9e4e562b4843833c9_180_135.jpg?1564827798","sPortait":"https://v-cms-img.huya.com/huya/201912ND/photov2/130.png","sBriefText":"和平精英女神主播，战略吃鸡小能手"},"iRank":7,"lScore":10516090},{"tJump":{"lPid":1503332370,"lTid":0,"lSid":0,"iGameId":0,"lYYId":1686097543,"iRoomId":52880},"tPresenter":{"lPid":1503332370,"sNickName":"血色-BB文","sLogoUrl":"http://huyaimg.msstatic.com/avatar/1001/78/859091a71db0eaec7b6c24ab4cff5c_180_135.jpg?1460197317","sPortait":"https://v-cms-img.huya.com/huya/201912ND/photov2/102.png","sBriefText":"国服第一德莱文，LOL、吃鸡双料大神"},"iRank":8,"lScore":10115334},{"tJump":{"lPid":1810857792,"lTid":0,"lSid":0,"iGameId":0,"lYYId":2063491321,"iRoomId":12020},"tPresenter":{"lPid":1810857792,"sNickName":"虎牙-小雪","sLogoUrl":"https://huyaimg.msstatic.com/avatar/1001/b9/2be817c88623afbbbd2037c3dd29d5_180_135.jpg?1568516792","sPortait":"https://v-cms-img.huya.com/huya/201912ND/photov2/107.png","sBriefText":"王者荣耀人气主播，颜值与实力俱全"},"iRank":9,"lScore":10288804},{"tJump":{"lPid":172162826,"lTid":0,"lSid":0,"iGameId":0,"lYYId":5801963,"iRoomId":12388},"tPresenter":{"lPid":172162826,"sNickName":"AzZ丶小古子","sLogoUrl":"https://huyaimg.msstatic.com/avatar/1059/3e/b8693669c23888a6f4a07b219e9f4b_180_135.jpg?1575449867","sPortait":"https://v-cms-img.huya.com/huya/201912ND/photov2/121.png","sBriefText":"DNF人气主播，装备爆率专家"},"iRank":10,"lScore":10073034},{"tJump":{"lPid":1402405258,"lTid":0,"lSid":0,"iGameId":0,"lYYId":908210,"iRoomId":625910},"tPresenter":{"lPid":1402405258,"sNickName":"诺米-阿萱","sLogoUrl":"https://huyaimg.msstatic.com/avatar/1060/a7/97a70dfdfceee306457864f2229fcd_180_135.jpg?1576578100","sPortait":"https://v-cms-img.huya.com/huya/201912ND/photov2/126.png","sBriefText":"性感狂野，操作彪悍，宠粉狂魔百星女野王"},"iRank":11,"lScore":10910734},{"tJump":{"lPid":2214877816,"lTid":0,"lSid":0,"iGameId":0,"lYYId":2215084612,"iRoomId":110775},"tPresenter":{"lPid":2214877816,"sNickName":"DK-冬季【傻】","sLogoUrl":"http://huyaimg.msstatic.com/avatar/1022/64/2749ab9789c4057d5ce832ec936442_180_135.jpg?1518517930","sPortait":"https://v-cms-img.huya.com/huya/201912ND/photov2/112.png","sBriefText":"DKG战队队长，吃鸡技术超一流，WC吃鸡研究所所长"},"iRank":12,"lScore":7836217},{"tJump":{"lPid":1676306798,"lTid":0,"lSid":0,"iGameId":0,"lYYId":1907672218,"iRoomId":77520},"tPresenter":{"lPid":1676306798,"sNickName":"AzZ丶莫雨熙","sLogoUrl":"https://huyaimg.msstatic.com/avatar/1033/07/a981dbe5802c598d6731ec40814267_180_135.jpg?1568426693","sPortait":"https://v-cms-img.huya.com/huya/201912ND/photov2/108.png","sBriefText":"穿越火线人气美女主播，天才游戏少女"},"iRank":13,"lScore":2421105},{"tJump":{"lPid":1632563722,"lTid":49488231,"lSid":49488231,"iGameId":3203,"lYYId":1851124717,"iRoomId":863214},"tPresenter":{"lPid":1632563722,"sNickName":"DK-晚玉","sLogoUrl":"https://huyaimg.msstatic.com/avatar/1010/12/4b53e2955341c7bdea36fd43b7c7f3_180_135.jpg?1576573675","sPortait":"https://v-cms-img.huya.com/huya/201912ND/photov2/131.png","sBriefText":"和平精英五指狙王，98K专家"},"iRank":14,"lScore":2272702},{"tJump":{"lPid":500066171,"lTid":0,"lSid":0,"iGameId":0,"lYYId":917707,"iRoomId":13579},"tPresenter":{"lPid":500066171,"sNickName":"狂鸟丶董小飒-90327","sLogoUrl":"http://huyaimg.msstatic.com/avatar/1082/64/b3bb6f0caa54e70a0391bceab9e093_180_135.jpg?1482606779","sPortait":"https://v-cms-img.huya.com/huya/201912ND/photov2/117.png","sBriefText":"知名电竞元老，多款游戏顶尖玩家董导董小飒"},"iRank":15,"lScore":1774174},{"tJump":{"lPid":2285403183,"lTid":0,"lSid":0,"iGameId":0,"lYYId":2285510344,"iRoomId":678398},"tPresenter":{"lPid":2285403183,"sNickName":"Dae-六尾","sLogoUrl":"https://huyaimg.msstatic.com/avatar/1028/29/4bafcf599029eae6cb7433c439503b_180_135.jpg?1530351273","sPortait":"https://v-cms-img.huya.com/huya/201912ND/photov2/129.png","sBriefText":"国服守约，甩狙达人，普通话一级甲等"},"iRank":21,"lScore":320702},{"tJump":{"lPid":2230044809,"lTid":1443972176,"lSid":1443972176,"iGameId":3203,"lYYId":2230034393,"iRoomId":331272},"tPresenter":{"lPid":2230044809,"sNickName":"Dae-小抠脚","sLogoUrl":"https://huyaimg.msstatic.com/avatar/1012/ec/62d281aef2150311ed11e5d8c2f79d_180_135.jpg?1536230188","sPortait":"https://v-cms-img.huya.com/huya/201912ND/photov2/132.png","sBriefText":"吃鸡狙神，国服双人榜一大神，新晋吃鸡男神"},"iRank":22,"lScore":261356},{"tJump":{"lPid":1199515480194,"lTid":0,"lSid":0,"iGameId":0,"lYYId":35184379918954,"iRoomId":641641},"tPresenter":{"lPid":1199515480194,"sNickName":"mlxgzzz","sLogoUrl":"https://huyaimg.msstatic.com/avatar/1033/f2/11455c384827db103ce7839aa73540_180_135.jpg?1567318108","sPortait":"https://v-cms-img.huya.com/huya/201912ND/photov2/105.png","sBriefText":"LOL亚运会冠军，前职业选手，刷人型打野"},"iRank":23,"lScore":199046},{"tJump":{"lPid":7223465,"lTid":0,"lSid":0,"iGameId":0,"lYYId":32041337,"iRoomId":411775},"tPresenter":{"lPid":7223465,"sNickName":"悦帆-神机","sLogoUrl":"https://huyaimg.msstatic.com/avatar/1005/d7/6594169a89c0bde09c772a05760262_180_135.jpg?1547051316","sPortait":"https://v-cms-img.huya.com/huya/201912ND/photov2/127.png","sBriefText":"穿越火线人气主播，CF最靓的仔"},"iRank":24,"lScore":61537},{"tJump":{"lPid":1699667589,"lTid":49063860,"lSid":49063860,"iGameId":3203,"lYYId":1937785968,"iRoomId":417964},"tPresenter":{"lPid":1699667589,"sNickName":"DK-董系长","sLogoUrl":"https://huyaimg.msstatic.com/avatar/1069/05/051fddc8a4574f12952da556d4691b_180_135.jpg?1568862192","sPortait":"https://v-cms-img.huya.com/huya/201912ND/photov2/114.png","sBriefText":"和平精英知名主播，带妹达人"},"iRank":25,"lScore":57887},{"tJump":{"lPid":2188711921,"lTid":0,"lSid":0,"iGameId":0,"lYYId":2188705355,"iRoomId":693948},"tPresenter":{"lPid":2188711921,"sNickName":"远方","sLogoUrl":"https://huyaimg.msstatic.com/avatar/1043/83/7cf2b6b46c884ee5877a625ecc72d1_180_135.jpg?1553073357","sPortait":"https://v-cms-img.huya.com/huya/201912ND/photov2/125.png","sBriefText":"王者荣耀祭猪流创始人，国一后羿"},"iRank":26,"lScore":46808},{"tJump":{"lPid":61816601,"lTid":0,"lSid":0,"iGameId":0,"lYYId":4705704,"iRoomId":527171},"tPresenter":{"lPid":61816601,"sNickName":"血色-kiki【717】","sLogoUrl":"https://huyaimg.msstatic.com/avatar/1065/a3/0cc3594b9a6e3a0aece74c74cfc8cd_180_135.jpg?1574443437","sPortait":"https://v-cms-img.huya.com/huya/201912ND/photov2/113.png","sBriefText":"英雄联盟人气美女主播"},"iRank":27,"lScore":25137},{"tJump":{"lPid":1682308317,"lTid":0,"lSid":0,"iGameId":0,"lYYId":1916064369,"iRoomId":12480555},"tPresenter":{"lPid":1682308317,"sNickName":"你的阿深吖","sLogoUrl":"https://huyaimg.msstatic.com/avatar/1004/d8/45748e0a375ad41f2901511ea032ae_180_135.jpg?1554697336","sPortait":"https://v-cms-img.huya.com/huya/201912ND/photov2/000.png","sBriefText":"王者荣耀新星主播，任何英雄全能秀"},"iRank":28,"lScore":23804},{"tJump":{"lPid":1199519096737,"lTid":0,"lSid":0,"iGameId":0,"lYYId":35184394416679,"iRoomId":19882011},"tPresenter":{"lPid":1199519096737,"sNickName":"星盛-球球","sLogoUrl":"https://huyaimg.msstatic.com/avatar/1051/ee/2163b81864b8e3c4aaa8f082701ecd_180_135.jpg?1569409330","sPortait":"https://v-cms-img.huya.com/huya/201912ND/photov2/000.png","sBriefText":"王者荣耀美女主播"},"iRank":29,"lScore":6826}]},"iStage":6,"iArea":4,"sStageTips":""},
    yule: {"vRank":{"proto":{"tJump":{"lPid":0,"lTid":0,"lSid":0,"iGameId":0,"lYYId":0,"iRoomId":0},"tPresenter":{"lPid":0,"sNickName":"","sLogoUrl":"","sPortait":"","sBriefText":""},"iRank":0,"lScore":0},"value":[{"tJump":{"lPid":1497334633,"lTid":54624515,"lSid":54624515,"iGameId":1663,"lYYId":9211567,"iRoomId":929211},"tPresenter":{"lPid":1497334633,"sNickName":"血色-小伊伊Eva","sLogoUrl":"http://huyaimg.msstatic.com/avatar/1041/fc/c5c05ea43d32b6fdf8e0090a2f31a9_180_135.jpg?1493058260","sPortait":"https://v-cms-img.huya.com/huya/201912ND/photov2/215.png","sBriefText":"天籁之音，倾城之颜，一心EE，血色有你！"},"iRank":1,"lScore":12912912},{"tJump":{"lPid":2191937829,"lTid":0,"lSid":0,"iGameId":0,"lYYId":2192155069,"iRoomId":622148},"tPresenter":{"lPid":2191937829,"sNickName":"Qz-溪宝宝77","sLogoUrl":"https://huyaimg.msstatic.com/avatar/1095/b9/1063f5c9bc009995131f65f8199906_180_135.jpg?1563722147","sPortait":"https://v-cms-img.huya.com/huya/201912ND/photov2/205.png","sBriefText":"全能型主播，外表甜美靓丽，被唱歌耽误的灵魂画手"},"iRank":2,"lScore":12504106},{"tJump":{"lPid":1768824951,"lTid":0,"lSid":0,"iGameId":0,"lYYId":2021420942,"iRoomId":92555},"tPresenter":{"lPid":1768824951,"sNickName":"正恒丶巫曼【555】","sLogoUrl":"https://huyaimg.msstatic.com/avatar/1059/94/dbf2f2d2233850828b73c7f544e3a1_180_135.jpg?1574705288","sPortait":"https://v-cms-img.huya.com/huya/201912ND/photov2/207.png","sBriefText":"森系治愈嗓音，可甜可咸"},"iRank":3,"lScore":10378473},{"tJump":{"lPid":1199518828666,"lTid":0,"lSid":0,"iGameId":0,"lYYId":35184393089978,"iRoomId":52007},"tPresenter":{"lPid":1199518828666,"sNickName":"奇领小鲁班","sLogoUrl":"https://huyaimg.msstatic.com/avatar/1070/ad/619cee97998fa27b31f64e8df23836_180_135.jpg?1573570456","sPortait":"https://v-cms-img.huya.com/huya/201912ND/photov2/203.png","sBriefText":"星秀暖心系歌手，游戏搞笑型选手"},"iRank":4,"lScore":9443584},{"tJump":{"lPid":1370015765,"lTid":0,"lSid":0,"iGameId":0,"lYYId":1517224769,"iRoomId":291616},"tPresenter":{"lPid":1370015765,"sNickName":"小妖潘妮","sLogoUrl":"https://huyaimg.msstatic.com/avatar/1047/78/a976fb7be53376f28ef2b875da04d9_180_135.jpg?1566841778","sPortait":"https://v-cms-img.huya.com/huya/201912ND/photov2/229.png","sBriefText":"36D长腿双马尾"},"iRank":5,"lScore":8562995},{"tJump":{"lPid":1636796409,"lTid":0,"lSid":0,"iGameId":0,"lYYId":5120495,"iRoomId":92925},"tPresenter":{"lPid":1636796409,"sNickName":"JV-皮皮宝宝【925】","sLogoUrl":"https://huyaimg.msstatic.com/avatar/1068/50/9424410e75c56ab42a6561f46d0d08_180_135.jpg?1570660738","sPortait":"https://v-cms-img.huya.com/huya/201912ND/photov2/216.png","sBriefText":"甜美小萌仙，歌声婉转的阳光精灵"},"iRank":6,"lScore":9372422},{"tJump":{"lPid":1847969530,"lTid":1419855525,"lSid":1419855525,"iGameId":1663,"lYYId":2100584188,"iRoomId":521715},"tPresenter":{"lPid":1847969530,"sNickName":"集梦小叶子","sLogoUrl":"https://huyaimg.msstatic.com/avatar/1037/4d/c9d3d5b14634cf538fbb832968b855_180_135.jpg?1577509025","sPortait":"https://v-cms-img.huya.com/huya/201912ND/photov2/209.png","sBriefText":"快乐精灵，舰队少女"},"iRank":7,"lScore":8969483},{"tJump":{"lPid":1768714932,"lTid":78607859,"lSid":78607859,"iGameId":1663,"lYYId":2021320845,"iRoomId":553420},"tPresenter":{"lPid":1768714932,"sNickName":"血色-小狐狸","sLogoUrl":"https://huyaimg.msstatic.com/avatar/1082/58/49696c3b95ff327cc3402b05eb845b_180_135.jpg?1570626374","sPortait":"https://v-cms-img.huya.com/huya/201912ND/photov2/210.png","sBriefText":"初恋味道 清纯女神 歌声悦耳 楚楚动人"},"iRank":8,"lScore":8776251},{"tJump":{"lPid":1096896069,"lTid":0,"lSid":0,"iGameId":0,"lYYId":8445266,"iRoomId":29021},"tPresenter":{"lPid":1096896069,"sNickName":"正恒YJ-画心【老姨】","sLogoUrl":"https://huyaimg.msstatic.com/avatar/1009/60/f418558d9d2445b5043a9eda512d1a_180_135.jpg?1558673448","sPortait":"https://v-cms-img.huya.com/huya/201912ND/photov2/212.png","sBriefText":"画心“老姨”，虎牙资深娱乐导师"},"iRank":9,"lScore":8794758},{"tJump":{"lPid":486806573,"lTid":0,"lSid":0,"iGameId":0,"lYYId":690989,"iRoomId":520529},"tPresenter":{"lPid":486806573,"sNickName":"MH丶橘夏【529】","sLogoUrl":"https://huyaimg.msstatic.com/avatar/1035/9a/d10a7948240e56a494410d875d620b_180_135.jpg?1550092681","sPortait":"https://v-cms-img.huya.com/huya/201912ND/photov2/218.png","sBriefText":"可萌可御，风格百变"},"iRank":10,"lScore":8232762},{"tJump":{"lPid":1860982765,"lTid":0,"lSid":0,"iGameId":0,"lYYId":2113558253,"iRoomId":518512},"tPresenter":{"lPid":1860982765,"sNickName":"呆萌可爱石","sLogoUrl":"https://huyaimg.msstatic.com/avatar/1080/86/c1b9882deaa1cb8c1f0875ef5f8475_180_135.jpg?1577215615","sPortait":"https://v-cms-img.huya.com/huya/201912ND/photov2/202.png","sBriefText":"颜值爆表，歌声动人"},"iRank":11,"lScore":7508834},{"tJump":{"lPid":2272316519,"lTid":0,"lSid":0,"iGameId":0,"lYYId":2272348727,"iRoomId":199585},"tPresenter":{"lPid":2272316519,"sNickName":"小小小酷哥【朵】","sLogoUrl":"https://huyaimg.msstatic.com/avatar/1056/cc/2ae247f33b3d03046c0b41eddf8ac9_180_135.jpg?1577521385","sPortait":"https://v-cms-img.huya.com/huya/201912ND/photov2/219.png","sBriefText":"95后恋爱剧本制作人"},"iRank":12,"lScore":6644082},{"tJump":{"lPid":831305549,"lTid":0,"lSid":0,"iGameId":0,"lYYId":90112,"iRoomId":2511},"tPresenter":{"lPid":831305549,"sNickName":"AzZ丶沐莹莹【251】","sLogoUrl":"https://huyaimg.msstatic.com/avatar/1003/60/d8fe78247c7229b9be220d6b457e8f_180_135.jpg?1570517005","sPortait":"https://v-cms-img.huya.com/huya/201912ND/photov2/208.png","sBriefText":"白羊座美少女，声甜貌美大长腿"},"iRank":13,"lScore":3073777},{"tJump":{"lPid":333838997,"lTid":0,"lSid":0,"iGameId":0,"lYYId":245366328,"iRoomId":52821},"tPresenter":{"lPid":333838997,"sNickName":"血色-深坑【皓徒】","sLogoUrl":"https://huyaimg.msstatic.com/avatar/1024/6a/c4cb432ff2274d70a275c63031a0d6_180_135.jpg?1567094573","sPortait":"https://v-cms-img.huya.com/huya/201912ND/photov2/213.png","sBriefText":"新闻有深度，直播不挖坑、新闻就看深坑"},"iRank":14,"lScore":2563765},{"tJump":{"lPid":1199511984117,"lTid":0,"lSid":0,"iGameId":0,"lYYId":35184375578844,"iRoomId":922666},"tPresenter":{"lPid":1199511984117,"sNickName":"宛廷【空舞艺术】","sLogoUrl":"https://huyaimg.msstatic.com/avatar/1016/75/61e809b08780b76c5917ba0bbdbc53_180_135.jpg?1574071477","sPortait":"https://v-cms-img.huya.com/huya/201912ND/photov2/224.png","sBriefText":"一生只为你而舞"},"iRank":15,"lScore":2287709},{"tJump":{"lPid":1609379782,"lTid":0,"lSid":0,"iGameId":0,"lYYId":1821733235,"iRoomId":523980},"tPresenter":{"lPid":1609379782,"sNickName":"表面兄弟-子龙【3980】","sLogoUrl":"https://huyaimg.msstatic.com/avatar/1090/6d/70356d616a09fbf475bf552fe17994_180_135.jpg?1537384392","sPortait":"https://v-cms-img.huya.com/huya/201912ND/photov2/204.png","sBriefText":"虎牙业内“吐槽大会”的talk king，说唱小王子"},"iRank":21,"lScore":596750},{"tJump":{"lPid":1510793610,"lTid":0,"lSid":0,"iGameId":0,"lYYId":835277,"iRoomId":525277},"tPresenter":{"lPid":1510793610,"sNickName":"苏柒柒","sLogoUrl":"https://huyaimg.msstatic.com/avatar/1089/1c/02621f50cc9249f2ebb7c25700b9fb_180_135.jpg?1577522747","sPortait":"https://v-cms-img.huya.com/huya/201912ND/photov2/220.png","sBriefText":"不落俗尘的音乐电台"},"iRank":22,"lScore":334426},{"tJump":{"lPid":2297371393,"lTid":1448025391,"lSid":1448025391,"iGameId":2165,"lYYId":2297369655,"iRoomId":501781},"tPresenter":{"lPid":2297371393,"sNickName":"微山湖户外【赢城】","sLogoUrl":"https://huyaimg.msstatic.com/avatar/1094/17/335aa900444f38cef49f1be84a1d69_180_135.jpg?1573909933","sPortait":"https://v-cms-img.huya.com/huya/201912ND/photov2/211.png","sBriefText":"全能型打野主播，带你捕鱼摸虾体验乡野欢乐"},"iRank":23,"lScore":258030},{"tJump":{"lPid":2178953218,"lTid":0,"lSid":0,"iGameId":0,"lYYId":2178879593,"iRoomId":520006},"tPresenter":{"lPid":2178953218,"sNickName":"依然是婷er【006】","sLogoUrl":"https://huyaimg.msstatic.com/avatar/1060/ce/6f544432cefbb3c322c4fd143b01fb_180_135.jpg?1569067537","sPortait":"https://v-cms-img.huya.com/huya/201912ND/photov2/225.png","sBriefText":"百变女神皮皮婷，甜美的长相，性感的身材，会唱会跳"},"iRank":24,"lScore":162194},{"tJump":{"lPid":1152853669,"lTid":0,"lSid":0,"iGameId":0,"lYYId":1240641848,"iRoomId":358947},"tPresenter":{"lPid":1152853669,"sNickName":"鑫蒙-小太阳","sLogoUrl":"https://huyaimg.msstatic.com/avatar/1064/90/92ce8d0bb6f2d0d5c7fd5596161729_180_135.jpg?1576675707","sPortait":"https://v-cms-img.huya.com/huya/201912ND/photov2/226.png","sBriefText":"歌美人美的民谣女神，古灵精怪的小太阳"},"iRank":25,"lScore":86868},{"tJump":{"lPid":1786372890,"lTid":0,"lSid":0,"iGameId":0,"lYYId":2038972929,"iRoomId":926626},"tPresenter":{"lPid":1786372890,"sNickName":"626-江澜【尊师放纵】","sLogoUrl":"https://huyaimg.msstatic.com/avatar/1088/98/147e08afa9962b2ffba5692bb40015_180_135.jpg?1560397453","sPortait":"https://v-cms-img.huya.com/huya/201912ND/photov2/222.png","sBriefText":"超萌天仙小姐姐，灵动舞姿秀动全场"},"iRank":26,"lScore":78415},{"tJump":{"lPid":2185256980,"lTid":0,"lSid":0,"iGameId":0,"lYYId":2185497649,"iRoomId":18001},"tPresenter":{"lPid":2185256980,"sNickName":"烂虾【封刷】","sLogoUrl":"https://huyaimg.msstatic.com/avatar/1045/32/177910c7a4f6c7578491cf73683b44_180_135.jpg?1563209381","sPortait":"https://v-cms-img.huya.com/huya/201912ND/photov2/214.png","sBriefText":"下沙吴彦祖、杭州余文乐、分手大师、赛车、雷泽影院创始人"},"iRank":27,"lScore":17313},{"tJump":{"lPid":1199517668903,"lTid":0,"lSid":0,"iGameId":0,"lYYId":35184384504246,"iRoomId":190730},"tPresenter":{"lPid":1199517668903,"sNickName":"海王HW-洋洋【长安】","sLogoUrl":"https://huyaimg.msstatic.com/avatar/1065/11/f7cbd2b15c6f9c2828993eb8672df6_180_135.jpg?1576263821","sPortait":"https://v-cms-img.huya.com/huya/201912ND/photov2/227.png","sBriefText":"青春活力邻家美少女，琴棋书画诗酒乐，皆不精通。"},"iRank":28,"lScore":8157},{"tJump":{"lPid":2304616936,"lTid":0,"lSid":0,"iGameId":0,"lYYId":2304726620,"iRoomId":766518},"tPresenter":{"lPid":2304616936,"sNickName":"【Miu】婕希贝儿","sLogoUrl":"https://huyaimg.msstatic.com/avatar/1049/2d/0b94568958cca77f225bbaf3f7f853_180_135.jpg?1567014217","sPortait":"https://v-cms-img.huya.com/huya/201912ND/photov2/228.png","sBriefText":"魔鬼中的天使"},"iRank":29,"lScore":1389}]},"iStage":6,"iArea":5,"sStageTips":""},
    jiaoyou: {
      "vRank": {
          "proto": {
              "tJump": {
                  "lPid": 0,
                  "lTid": 0,
                  "lSid": 0,
                  "iGameId": 0,
                  "lYYId": 0,
                  "iRoomId": 0
              },
              "tPresenter": {
                  "lPid": 0,
                  "sNickName": "",
                  "sLogoUrl": "",
                  "sPortait": "",
                  "sBriefText": ""
              },
              "iRank": 0,
              "lScore": 0
          },
          "value": [{
              "tJump": {
                  "lPid": 1206518181,
                  "lTid": 29980038,
                  "lSid": 29980038,
                  "iGameId": 4079,
                  "lYYId": 1299092,
                  "iRoomId": 592655
              },
              "tPresenter": {
                  "lPid": 1206518181,
                  "sNickName": "【娱加】私人订制",
                  "sLogoUrl": "https://huyaimg.msstatic.com/avatar/1052/eb/e24acb17d7ccf1061e78bf50e0ae4f_180_135.jpg?1576467236",
                  "sPortait": "https://v-cms-img.huya.com/huya/201912ND/photov1/000.png",
                  "sBriefText": "年度总决选参赛主播..."
              },
              "iRank": 1,
              "lScore": 8278056
          },
          {
              "tJump": {
                  "lPid": 1674470414,
                  "lTid": 1349716756,
                  "lSid": 1349716756,
                  "iGameId": 4079,
                  "lYYId": 1905618175,
                  "iRoomId": 77213
              },
              "tPresenter": {
                  "lPid": 1674470414,
                  "sNickName": "Top-花花世界",
                  "sLogoUrl": "https://huyaimg.msstatic.com/avatar/1081/f4/4dcad96cb7651fab490c30780a439d_180_135.jpg?1548225957",
                  "sPortait": "https://v-cms-img.huya.com/huya/201912ND/photov1/000.png",
                  "sBriefText": "年度总决选参赛主播..."
              },
              "iRank": 2,
              "lScore": 4923313
          },
          {
              "tJump": {
                  "lPid": 873479969,
                  "lTid": 1446422620,
                  "lSid": 1446422620,
                  "iGameId": 4079,
                  "lYYId": 836277351,
                  "iRoomId": 520139
              },
              "tPresenter": {
                  "lPid": 873479969,
                  "sNickName": "Top-连麦吗",
                  "sLogoUrl": "https://huyaimg.msstatic.com/avatar/1053/ff/4842542b64a956a07724307f65812f_180_135.jpg?1563874218",
                  "sPortait": "https://v-cms-img.huya.com/huya/201912ND/photov1/000.png",
                  "sBriefText": "年度总决选参赛主播..."
              },
              "iRank": 3,
              "lScore": 3747750
          },
          {
              "tJump": {
                  "lPid": 1333018208,
                  "lTid": 1334376647,
                  "lSid": 1334376647,
                  "iGameId": 4079,
                  "lYYId": 1470026352,
                  "iRoomId": 17497319
              },
              "tPresenter": {
                  "lPid": 1333018208,
                  "sNickName": "化蝶-破茧成蝶",
                  "sLogoUrl": "https://huyaimg.msstatic.com/avatar/1096/e1/5ddf0dc4f50a5ce0d8151480ae41ad_180_135.jpg?1573590314",
                  "sPortait": "https://v-cms-img.huya.com/huya/201912ND/photov1/000.png",
                  "sBriefText": "年度总决选参赛主播..."
              },
              "iRank": 4,
              "lScore": 2833197
          },
          {
              "tJump": {
                  "lPid": 2305382498,
                  "lTid": 1446159505,
                  "lSid": 1446159505,
                  "iGameId": 4079,
                  "lYYId": 2305550865,
                  "iRoomId": 17760935
              },
              "tPresenter": {
                  "lPid": 2305382498,
                  "sNickName": "98-你的故事",
                  "sLogoUrl": "https://huyaimg.msstatic.com/avatar/1059/88/bb6877faa6b390ae73aafc91faab72_180_135.jpg?1576044016",
                  "sPortait": "https://v-cms-img.huya.com/huya/201912ND/photov1/000.png",
                  "sBriefText": "年度总决选参赛主播..."
              },
              "iRank": 5,
              "lScore": 1629033
          },
          {
              "tJump": {
                  "lPid": 2355579690,
                  "lTid": 1445489781,
                  "lSid": 1445489781,
                  "iGameId": 4079,
                  "lYYId": 2357396226,
                  "iRoomId": 31582
              },
              "tPresenter": {
                  "lPid": 2355579690,
                  "sNickName": "Dae-没有名字",
                  "sLogoUrl": "https://huyaimg.msstatic.com/avatar/1015/cc/e7a4b72372741a7cafc30e50b72fa1_180_135.jpg?1563118594",
                  "sPortait": "https://v-cms-img.huya.com/huya/201912ND/photov1/000.png",
                  "sBriefText": "年度总决选参赛主播..."
              },
              "iRank": 6,
              "lScore": 1493706
          },
          {
              "tJump": {
                  "lPid": 120130088,
                  "lTid": 1447113562,
                  "lSid": 1447113562,
                  "iGameId": 4079,
                  "lYYId": 96432890,
                  "iRoomId": 470286
              },
              "tPresenter": {
                  "lPid": 120130088,
                  "sNickName": "血色-随心所欲",
                  "sLogoUrl": "https://huyaimg.msstatic.com/avatar/1033/4b/2594d06a7e64c45c199accb2f09960_180_135.jpg?1573929917",
                  "sPortait": "https://v-cms-img.huya.com/huya/201912ND/photov1/000.png",
                  "sBriefText": "年度总决选参赛主播..."
              },
              "iRank": 7,
              "lScore": 1196532
          },
          {
              "tJump": {
                  "lPid": 2392215264,
                  "lTid": 1447970341,
                  "lSid": 1447970341,
                  "iGameId": 4079,
                  "lYYId": 2394157604,
                  "iRoomId": 19179543
              },
              "tPresenter": {
                  "lPid": 2392215264,
                  "sNickName": "豪门-年末厅站现场",
                  "sLogoUrl": "https://huyaimg.msstatic.com/avatar/1024/49/2ef78a32500a08f916d25d4fce1ac9_180_135.jpg?1563626692",
                  "sPortait": "https://v-cms-img.huya.com/huya/201912ND/photov1/000.png",
                  "sBriefText": "年度总决选参赛主播..."
              },
              "iRank": 8,
              "lScore": 1082814
          },
          {
              "tJump": {
                  "lPid": 362894679,
                  "lTid": 66228146,
                  "lSid": 66228146,
                  "iGameId": 4079,
                  "lYYId": 275688951,
                  "iRoomId": 18320593
              },
              "tPresenter": {
                  "lPid": 362894679,
                  "sNickName": "98-一起鬼混",
                  "sLogoUrl": "https://huyaimg.msstatic.com/avatar/1071/37/059cf96b0672714ed8192f3659111f_180_135.jpg?1576587419",
                  "sPortait": "https://v-cms-img.huya.com/huya/201912ND/photov1/000.png",
                  "sBriefText": "年度总决选参赛主播..."
              },
              "iRank": 9,
              "lScore": 1145838
          },
          {
              "tJump": {
                  "lPid": 946760229,
                  "lTid": 1446340555,
                  "lSid": 1446340555,
                  "iGameId": 4079,
                  "lYYId": 910987888,
                  "iRoomId": 86742
              },
              "tPresenter": {
                  "lPid": 946760229,
                  "sNickName": "Top-秋水伊人",
                  "sLogoUrl": "https://huyaimg.msstatic.com/avatar/1014/00/9e98e4245b4f7d1115f40a62717d16_180_135.jpg?1550845163",
                  "sPortait": "https://v-cms-img.huya.com/huya/201912ND/photov1/000.png",
                  "sBriefText": "年度总决选参赛主播..."
              },
              "iRank": 10,
              "lScore": 1085742
          },
          {
              "tJump": {
                  "lPid": 1199512780385,
                  "lTid": 1199512780385,
                  "lSid": 1199512780385,
                  "iGameId": 4079,
                  "lYYId": 35184376673061,
                  "iRoomId": 520635
              },
              "tPresenter": {
                  "lPid": 1199512780385,
                  "sNickName": "【娱加】万里挑一",
                  "sLogoUrl": "https://huyaimg.msstatic.com/avatar/1092/b5/be18c5b19debf764850da2d8d86975_180_135.jpg?1554644667",
                  "sPortait": "https://v-cms-img.huya.com/huya/201912ND/photov1/000.png",
                  "sBriefText": "年度总决选参赛主播..."
              },
              "iRank": 11,
              "lScore": 995765
          },
          {
              "tJump": {
                  "lPid": 60006210,
                  "lTid": 1444611422,
                  "lSid": 1444611422,
                  "iGameId": 4079,
                  "lYYId": 1073998,
                  "iRoomId": 564721
              },
              "tPresenter": {
                  "lPid": 60006210,
                  "sNickName": "繁星-怦然心动",
                  "sLogoUrl": "https://huyaimg.msstatic.com/avatar/1082/5a/6534e16e8b40ca93738d1f047de817_180_135.jpg?1548078597",
                  "sPortait": "https://v-cms-img.huya.com/huya/201912ND/photov1/000.png",
                  "sBriefText": "年度总决选参赛主播..."
              },
              "iRank": 12,
              "lScore": 756952
          },
          {
              "tJump": {
                  "lPid": 2354081084,
                  "lTid": 1445432236,
                  "lSid": 1445432236,
                  "iGameId": 4079,
                  "lYYId": 2356052339,
                  "iRoomId": 428705
              },
              "tPresenter": {
                  "lPid": 2354081084,
                  "sNickName": "星耀-暮色年華",
                  "sLogoUrl": "https://huyaimg.msstatic.com/avatar/1036/4b/11edc4dd5d29fb3bc35aead3a02bb7_180_135.jpg?1545029845",
                  "sPortait": "https://v-cms-img.huya.com/huya/201912ND/photov1/000.png",
                  "sBriefText": "年度总决选参赛主播..."
              },
              "iRank": 13,
              "lScore": 605456
          },
          {
              "tJump": {
                  "lPid": 998441753,
                  "lTid": 32315043,
                  "lSid": 32315043,
                  "iGameId": 4079,
                  "lYYId": 965445216,
                  "iRoomId": 10760065
              },
              "tPresenter": {
                  "lPid": 998441753,
                  "sNickName": "筑梦-吞吞吐吐",
                  "sLogoUrl": "https://huyaimg.msstatic.com/avatar/1017/4d/0d6518223f753af3ffc756fe760548_180_135.jpg?1569250489",
                  "sPortait": "https://v-cms-img.huya.com/huya/201912ND/photov1/000.png",
                  "sBriefText": "年度总决选参赛主播..."
              },
              "iRank": 14,
              "lScore": 574871
          },
          {
              "tJump": {
                  "lPid": 1199526397904,
                  "lTid": 1199526397904,
                  "lSid": 1199526397904,
                  "iGameId": 4079,
                  "lYYId": 35184432630979,
                  "iRoomId": 20450418
              },
              "tPresenter": {
                  "lPid": 1199526397904,
                  "sNickName": "Dae-一晌贪欢",
                  "sLogoUrl": "https://huyaimg.msstatic.com/avatar/1059/7f/5d30bc8c2b782ad9cd56a152602ac8_180_135.jpg?1575726472",
                  "sPortait": "https://v-cms-img.huya.com/huya/201912ND/photov1/000.png",
                  "sBriefText": "年度总决选参赛主播..."
              },
              "iRank": 15,
              "lScore": 502320
          },
          {
              "tJump": {
                  "lPid": 1199517349201,
                  "lTid": 1199517349201,
                  "lSid": 1199517349201,
                  "iGameId": 4079,
                  "lYYId": 35184383081873,
                  "iRoomId": 557143
              },
              "tPresenter": {
                  "lPid": 1199517349201,
                  "sNickName": "蓝云-青丘狐",
                  "sLogoUrl": "https://huyaimg.msstatic.com/avatar/1032/67/d5c5402b4a951bb99b938375a8d008_180_135.jpg?1573628322",
                  "sPortait": "https://v-cms-img.huya.com/huya/201912ND/photov1/000.png",
                  "sBriefText": "年度总决选参赛主播..."
              },
              "iRank": 16,
              "lScore": 353867
          },
          {
              "tJump": {
                  "lPid": 1199515598914,
                  "lTid": 0,
                  "lSid": 0,
                  "iGameId": 0,
                  "lYYId": 35184380033887,
                  "iRoomId": 18642909
              },
              "tPresenter": {
                  "lPid": 1199515598914,
                  "sNickName": "星娱-悦目佳人",
                  "sLogoUrl": "https://huyaimg.msstatic.com/avatar/1098/3f/45ff62cbb4e323b9d875458389679c_180_135.jpg?1562254167",
                  "sPortait": "https://v-cms-img.huya.com/huya/201912ND/photov1/000.png",
                  "sBriefText": "年度总决选参赛主播..."
              },
              "iRank": 17,
              "lScore": 344190
          },
          {
              "tJump": {
                  "lPid": 1199525690638,
                  "lTid": 1199525690638,
                  "lSid": 1199525690638,
                  "iGameId": 4079,
                  "lYYId": 35184429394323,
                  "iRoomId": 20299925
              },
              "tPresenter": {
                  "lPid": 1199525690638,
                  "sNickName": "Agony-鲸落十里",
                  "sLogoUrl": "https://huyaimg.msstatic.com/avatar/1090/c2/25e0a7ee40a57f02feca30c02afb46_180_135.jpg?1573964281",
                  "sPortait": "https://v-cms-img.huya.com/huya/201912ND/photov1/000.png",
                  "sBriefText": "年度总决选参赛主播..."
              },
              "iRank": 18,
              "lScore": 294718
          },
          {
              "tJump": {
                  "lPid": 2323956996,
                  "lTid": 1444135603,
                  "lSid": 1444135603,
                  "iGameId": 4079,
                  "lYYId": 2325993034,
                  "iRoomId": 16533391
              },
              "tPresenter": {
                  "lPid": 2323956996,
                  "sNickName": "98-良辰美景",
                  "sLogoUrl": "https://huyaimg.msstatic.com/avatar/1014/cf/7d8ea2d5f0e3bfab4c218529d67222_180_135.jpg?1576498195",
                  "sPortait": "https://v-cms-img.huya.com/huya/201912ND/photov1/000.png",
                  "sBriefText": "年度总决选参赛主播..."
              },
              "iRank": 19,
              "lScore": 276970
          },
          {
              "tJump": {
                  "lPid": 1199518004163,
                  "lTid": 1199518004163,
                  "lSid": 1199518004163,
                  "iGameId": 4079,
                  "lYYId": 35184387974891,
                  "iRoomId": 665721
              },
              "tPresenter": {
                  "lPid": 1199518004163,
                  "sNickName": "欢c-開心乐园",
                  "sLogoUrl": "https://huyaimg.msstatic.com/avatar/1000/cc/49314f77260bad075893502966ef71_180_135.jpg?1577503794",
                  "sPortait": "https://v-cms-img.huya.com/huya/201912ND/photov1/000.png",
                  "sBriefText": "年度总决选参赛主播..."
              },
              "iRank": 20,
              "lScore": 252889
          },
          {
              "tJump": {
                  "lPid": 1199523665911,
                  "lTid": 1199523665911,
                  "lSid": 1199523665911,
                  "iGameId": 4079,
                  "lYYId": 35184418820029,
                  "iRoomId": 20013649
              },
              "tPresenter": {
                  "lPid": 1199523665911,
                  "sNickName": "Dae-勿忘初心",
                  "sLogoUrl": "https://huyaimg.msstatic.com/avatar/1099/33/1205fde5a8fc5809e3167a6bf057cb_180_135.jpg?1576485334",
                  "sPortait": "https://v-cms-img.huya.com/huya/201912ND/photov1/000.png",
                  "sBriefText": "年度总决选参赛主播..."
              },
              "iRank": 21,
              "lScore": 170397
          },
          {
              "tJump": {
                  "lPid": 2391730734,
                  "lTid": 1446926249,
                  "lSid": 1446926249,
                  "iGameId": 4079,
                  "lYYId": 2393597341,
                  "iRoomId": 18345029
              },
              "tPresenter": {
                  "lPid": 2391730734,
                  "sNickName": "Dae-日久生情",
                  "sLogoUrl": "https://huyaimg.msstatic.com/avatar/1070/e6/917b2e84c7a0a522d37fcd02b49d57_180_135.jpg?1574734902",
                  "sPortait": "https://v-cms-img.huya.com/huya/201912ND/photov1/000.png",
                  "sBriefText": "年度总决选参赛主播..."
              },
              "iRank": 22,
              "lScore": 155751
          },
          {
              "tJump": {
                  "lPid": 1199516542702,
                  "lTid": 1199516542702,
                  "lSid": 1199516542702,
                  "iGameId": 4079,
                  "lYYId": 35184381027372,
                  "iRoomId": 331428
              },
              "tPresenter": {
                  "lPid": 1199516542702,
                  "sNickName": "血色-战神归来",
                  "sLogoUrl": "https://huyaimg.msstatic.com/avatar/1096/78/537d8d5d7a1eab20059bfe34d96e44_180_135.jpg?1573315111",
                  "sPortait": "https://v-cms-img.huya.com/huya/201912ND/photov1/000.png",
                  "sBriefText": "年度总决选参赛主播..."
              },
              "iRank": 23,
              "lScore": 108720
          },
          {
              "tJump": {
                  "lPid": 1199523981286,
                  "lTid": 1199523981286,
                  "lSid": 1199523981286,
                  "iGameId": 4079,
                  "lYYId": 35184419898979,
                  "iRoomId": 54713
              },
              "tPresenter": {
                  "lPid": 1199523981286,
                  "sNickName": "Top-恋爱吗",
                  "sLogoUrl": "https://huyaimg.msstatic.com/avatar/1045/2a/6aba12b2fea8a65aeb94f210e51cc5_180_135.jpg?1575218360",
                  "sPortait": "https://v-cms-img.huya.com/huya/201912ND/photov1/000.png",
                  "sBriefText": "年度总决选参赛主播..."
              },
              "iRank": 24,
              "lScore": 96669
          },
          {
              "tJump": {
                  "lPid": 829837885,
                  "lTid": 1446267601,
                  "lSid": 1446267601,
                  "iGameId": 4079,
                  "lYYId": 790308219,
                  "iRoomId": 17829542
              },
              "tPresenter": {
                  "lPid": 829837885,
                  "sNickName": "Top-网恋",
                  "sLogoUrl": "https://huyaimg.msstatic.com/avatar/1068/e7/69084e12ec61584a12a2d034373bdb_180_135.jpg?1576656288",
                  "sPortait": "https://v-cms-img.huya.com/huya/201912ND/photov1/000.png",
                  "sBriefText": "年度总决选参赛主播..."
              },
              "iRank": 25,
              "lScore": 94279
          },
          {
              "tJump": {
                  "lPid": 946052606,
                  "lTid": 0,
                  "lSid": 0,
                  "iGameId": 0,
                  "lYYId": 35184414042715,
                  "iRoomId": 19873006
              },
              "tPresenter": {
                  "lPid": 946052606,
                  "sNickName": "Top-恋爱",
                  "sLogoUrl": "https://huyaimg.msstatic.com/avatar/1047/9c/24b77bfff9be248e362bf2e17b1242_180_135.jpg?1574700341",
                  "sPortait": "https://v-cms-img.huya.com/huya/201912ND/photov1/000.png",
                  "sBriefText": "年度总决选参赛主播..."
              },
              "iRank": 26,
              "lScore": 84681
          }]
      },
      "iStage": 6,
      "iArea": 6,
      "sStageTips": ""
  },
    richRank: {'vRankList': {'proto': {'lUid': 0, 'iRank': 0, 'lScore': 0, 'sNickName': '', 'sLogoUrl': '', 'iLabel': 0}, 'value': [{'lUid': 1700846846, 'iRank': 1, 'lScore': 64818651, 'sNickName': '君子固穷【烟雨楼】退', 'sLogoUrl': 'https://huyaimg.msstatic.com/avatar/1074/42/cc2a25c380c9519be6f4d34ffe4457_180_135.jpg?1536705529', 'iLabel': 1}, {'lUid': 1199517081998, 'iRank': 2, 'lScore': 61838613, 'sNickName': '上帝的宠儿【烟雨楼】', 'sLogoUrl': 'https://huyaimg.msstatic.com/avatar/1006/13/6b442304a0147ec26205844d391ccf_180_135.jpg?1561057825', 'iLabel': 1}, {'lUid': 2324519688, 'iRank': 3, 'lScore': 59521281, 'sNickName': '镇山河【烟雨楼】', 'sLogoUrl': 'https://huyaimg.msstatic.com/avatar/1052/dd/26ee050b62aabfa466a06d95208a94_180_135.jpg?1576819432', 'iLabel': 1}, {'lUid': 2304844074, 'iRank': 4, 'lScore': 42629218, 'sNickName': '白衣染霜华【烟雨楼】退', 'sLogoUrl': 'https://huyaimg.msstatic.com/avatar/1025/1d/e5c41ee92d3ee9589c5d5704afc1d2_180_135.jpg?1544733450', 'iLabel': 1}, {'lUid': 2196324330, 'iRank': 5, 'lScore': 41105113, 'sNickName': '血色卡拉xsnh9135', 'sLogoUrl': 'https://huyaimg.msstatic.com/avatar/1075/de/dcadf3e931566ed23a6284050d95c8_180_135.jpg?1540270933', 'iLabel': 1}, {'lUid': 863476536, 'iRank': 6, 'lScore': 34202511, 'sNickName': '奇领丶打发时间', 'sLogoUrl': 'https://huyaimg.msstatic.com/avatar/1094/6f/5ccfeafbc7824dc0d1e628656a4c45_180_135.jpg?1576924592', 'iLabel': 1}, {'lUid': 1259522486935, 'iRank': 7, 'lScore': 28045462, 'sNickName': '血色-小狐狸【时间】', 'sLogoUrl': 'https://huyaimg.msstatic.com/avatar/1041/f0/3c7311559d1e3309e9371a19a14616_180_135.jpg?1573366772', 'iLabel': 1}, {'lUid': 1349021585, 'iRank': 8, 'lScore': 24039955, 'sNickName': 'JV-晚上不吃饭', 'sLogoUrl': 'https://huyaimg.msstatic.com/avatar/1002/df/d570e511aebcf4259c6eb877436ebe_180_135.jpg?1535726666', 'iLabel': 1}, {'lUid': 1242448733, 'iRank': 9, 'lScore': 22608385, 'sNickName': '666', 'sLogoUrl': 'https://huyaimg.msstatic.com/avatar/1069/80/aa335fdc765c9ce2466d4a3e238a4b_180_135.jpg?1551081224', 'iLabel': 1}, {'lUid': 1831754311, 'iRank': 10, 'lScore': 21924345, 'sNickName': 'Allen【来年再干】', 'sLogoUrl': 'https://huyaimg.msstatic.com/avatar/1064/44/25f0422b218467e166434afbb08e44_180_135.jpg?1555611567', 'iLabel': 1}, {'lUid': 2271766239, 'iRank': 11, 'lScore': 18911160, 'sNickName': '宝塔镇河妖', 'sLogoUrl': 'https://huyaimg.msstatic.com/avatar/1016/af/44f94cc4e1a7607538f1950288ae58_180_135.jpg?1527824070', 'iLabel': 1}, {'lUid': 15755297, 'iRank': 12, 'lScore': 14888720, 'sNickName': '奇领丶嘻嘻嘻', 'sLogoUrl': 'https://huyaimg.msstatic.com/avatar/1009/cd/c1385ee933eb4c5a99e3f760a5486b_180_135.jpg?1573726406', 'iLabel': 1}, {'lUid': 1199521576253, 'iRank': 13, 'lScore': 13945938, 'sNickName': '寒门', 'sLogoUrl': 'https://huyaimg.msstatic.com/avatar/1027/3a/c03775de3d9ab2575539e936d1354c_180_135.jpg?1577089125', 'iLabel': 1}, {'lUid': 2338075853, 'iRank': 14, 'lScore': 11853428, 'sNickName': '阿拉蕾【251】', 'sLogoUrl': 'https://huyaimg.msstatic.com/avatar/1077/c4/df62544e46d064bf623a66a5e73b15_180_135.jpg?1562487802', 'iLabel': 1}, {'lUid': 2358170952, 'iRank': 15, 'lScore': 11711651, 'sNickName': '莎lala丶王权富贵【村】', 'sLogoUrl': 'https://huyaimg.msstatic.com/avatar/1077/b0/fcd51ca902150adebfa517439ddcf9_180_135.jpg?1545999110', 'iLabel': 1}, {'lUid': 1662275596, 'iRank': 16, 'lScore': 11489430, 'sNickName': 'AAA', 'sLogoUrl': 'https://huyaimg.msstatic.com/avatar/1035/30/ab1d79c85022c2b01c820e39577961_180_135.jpg?1558098941', 'iLabel': 1}, {'lUid': 1279512964436, 'iRank': 17, 'lScore': 11379419, 'sNickName': '依廷', 'sLogoUrl': 'https://huyaimg.msstatic.com/avatar/1048/69/e449ca007935b59e339a152e597638_180_135.jpg?1561437077', 'iLabel': 1}, {'lUid': 1299518648391, 'iRank': 18, 'lScore': 11276610, 'sNickName': '琴傲蜘蛛', 'sLogoUrl': 'https://huyaimg.msstatic.com/avatar/1039/16/e02fb5eef58a606d6add91504bc038_180_135.jpg?1577105867', 'iLabel': 1}, {'lUid': 1852867557, 'iRank': 19, 'lScore': 10698774, 'sNickName': 'Wanan', 'sLogoUrl': 'https://huyaimg.msstatic.com/avatar/1051/fa/2be27a0119933e065094c3c98e1615_180_135.jpg?1577329220', 'iLabel': 1}, {'lUid': 1199527014439, 'iRank': 20, 'lScore': 10061929, 'sNickName': '小流氓', 'sLogoUrl': 'https://huyaimg.msstatic.com/avatar/1089/28/0efa5c01920fdc70c578d4c97a8a4e_180_135.jpg?1576943748', 'iLabel': 1}, {'lUid': 1199517728742, 'iRank': 21, 'lScore': 8518389, 'sNickName': '国服第一韩信', 'sLogoUrl': 'https://huyaimg.msstatic.com/avatar/1011/14/0fea7cc727d15e74a12bc1f45fdf6b_180_135.jpg?1562074050', 'iLabel': 0}, {'lUid': 1706072103, 'iRank': 22, 'lScore': 8116598, 'sNickName': '集梦会长【超跑】', 'sLogoUrl': 'https://huyaimg.msstatic.com/avatar/1040/f6/2d1440b6b9108823c8fd370a3720e3_180_135.jpg?1539839211', 'iLabel': 0}, {'lUid': 1199526153911, 'iRank': 23, 'lScore': 7937827, 'sNickName': 'ee的自闭L', 'sLogoUrl': 'https://huyaimg.msstatic.com/avatar/1060/46/b1b20f9526925d9d359d98bbd1ac8a_180_135.jpg?1575033365', 'iLabel': 0}, {'lUid': 87015459, 'iRank': 24, 'lScore': 7099360, 'sNickName': '关总', 'sLogoUrl': '', 'iLabel': 0}, {'lUid': 1385389472, 'iRank': 25, 'lScore': 7093590, 'sNickName': '铭壕传媒', 'sLogoUrl': 'https://huyaimg.msstatic.com/avatar/1051/30/b640771b13fe1ca3c96621cfc2edf7_180_135.jpg?1574256860', 'iLabel': 0}, {'lUid': 2183211041, 'iRank': 26, 'lScore': 6663225, 'sNickName': '冷雨夜【闪电兔】', 'sLogoUrl': 'https://huyaimg.msstatic.com/avatar/1043/01/8751bd1f69ae0fdae5e3691bad9e52_180_135.jpg?1573501252', 'iLabel': 0}, {'lUid': 2197613011, 'iRank': 27, 'lScore': 6651834, 'sNickName': '宁思淼【退】', 'sLogoUrl': 'https://huyaimg.msstatic.com/avatar/1034/ee/8724aac34b26fed02821e25cdfc23e_180_135.jpg?1577202244', 'iLabel': 0}, {'lUid': 2502890905, 'iRank': 28, 'lScore': 5498834, 'sNickName': 'Rstar大师兄', 'sLogoUrl': 'https://huyaimg.msstatic.com/avatar/1040/1f/756d833dca647802cdbe9846cc5977_180_135.jpg?1574590433', 'iLabel': 0}, {'lUid': 340914610, 'iRank': 29, 'lScore': 5439091, 'sNickName': '楚楚河河', 'sLogoUrl': 'http://huyaimg.msstatic.com/avatar/1038/dc/23d828faae90fe44c1c9c9f9064675_180_135.jpg?0', 'iLabel': 0}, {'lUid': 68834720, 'iRank': 30, 'lScore': 5386346, 'sNickName': '傲之最-DNF', 'sLogoUrl': 'https://huyaimg.msstatic.com/avatar/1023/5a/819c305f26da5ced31107c02a38a0c_180_135.jpg?1573297877', 'iLabel': 0}, {'lUid': 1802102060, 'iRank': 31, 'lScore': 5376899, 'sNickName': '石头', 'sLogoUrl': '', 'iLabel': 0}, {'lUid': 1541269700, 'iRank': 32, 'lScore': 5282752, 'sNickName': '灵石-小铁矿', 'sLogoUrl': 'https://huyaimg.msstatic.com/avatar/1020/38/53894b62362fb021f6b64ae429e30f_180_135.jpg?1570701186', 'iLabel': 0}, {'lUid': 1235984726, 'iRank': 33, 'lScore': 5191046, 'sNickName': '骑猪撞大树', 'sLogoUrl': 'https://huyaimg.msstatic.com/avatar/1060/39/16b00827460c965a1a4340cd44c8e8_180_135.jpg?1528915601', 'iLabel': 0}, {'lUid': 1279522470951, 'iRank': 34, 'lScore': 4845109, 'sNickName': '啥也不是、715', 'sLogoUrl': 'https://huyaimg.msstatic.com/avatar/1092/4d/b8114b5a352748739b772ce8707eea_180_135.jpg?1577358909', 'iLabel': 0}, {'lUid': 1264524671, 'iRank': 35, 'lScore': 4456587, 'sNickName': '吃土军团丶浪浪', 'sLogoUrl': 'https://huyaimg.msstatic.com/avatar/1044/a2/7ac94a2e96f67a01f01eef3c196fde_180_135.jpg?1542611032', 'iLabel': 0}, {'lUid': 1199525787418, 'iRank': 36, 'lScore': 4092451, 'sNickName': '血色-烽火连城', 'sLogoUrl': 'https://huyaimg.msstatic.com/avatar/1076/3c/c6bc03d417aa6c634ddc9d369de57c_180_135.jpg?1574154267', 'iLabel': 0}, {'lUid': 2187322246, 'iRank': 37, 'lScore': 4036142, 'sNickName': '溪宝儿', 'sLogoUrl': 'https://huyaimg.msstatic.com/avatar/1057/f2/72e894cb4225f3496296e3393716d1_180_135.jpg?1577470898', 'iLabel': 0}, {'lUid': 1199516961282, 'iRank': 38, 'lScore': 3698279, 'sNickName': '宝子的小可爱场控赛文', 'sLogoUrl': 'https://huyaimg.msstatic.com/avatar/1025/71/1827961990a5f633a87523857059b7_180_135.jpg?1571993595', 'iLabel': 0}, {'lUid': 1757339664, 'iRank': 39, 'lScore': 3472217, 'sNickName': '小泽玛利亚【小象】', 'sLogoUrl': 'https://huyaimg.msstatic.com/avatar/1090/c6/5ba926502d7852c077bc2e7308cacc_180_135.jpg?1572335105', 'iLabel': 0}, {'lUid': 2277176599, 'iRank': 40, 'lScore': 3300060, 'sNickName': '关总', 'sLogoUrl': 'https://huyaimg.msstatic.com/avatar/1020/43/372ecf1328ebbc9b442ce08c3b67b0_180_135.jpg?1577095823', 'iLabel': 0}, {'lUid': 2234100134, 'iRank': 41, 'lScore': 3299670, 'sNickName': 'Dae-羽言', 'sLogoUrl': 'https://huyaimg.msstatic.com/avatar/1022/e5/20fce5fd0bd006f71d9fbb66567c2c_180_135.jpg?1542370703', 'iLabel': 0}, {'lUid': 1566987, 'iRank': 42, 'lScore': 3162108, 'sNickName': 'Pop-仔哥', 'sLogoUrl': 'https://huyaimg.msstatic.com/avatar/1065/31/d2f29059678cf305dbcd6b3ad3fcf3_180_135.jpg?1577531238', 'iLabel': 0}, {'lUid': 1628872998, 'iRank': 43, 'lScore': 2891581, 'sNickName': '千韶【集梦】', 'sLogoUrl': 'https://huyaimg.msstatic.com/avatar/1002/8b/08d8edaeaafac348be85789e6e84ad_180_135.jpg?1575330655', 'iLabel': 0}, {'lUid': 1199517497216, 'iRank': 44, 'lScore': 2724624, 'sNickName': 'ee的小银库', 'sLogoUrl': '', 'iLabel': 0}, {'lUid': 1199516319048, 'iRank': 45, 'lScore': 2669127, 'sNickName': '太上', 'sLogoUrl': 'https://huyaimg.msstatic.com/avatar/1084/ce/7563c3310201e323cec603e01b2494_180_135.jpg?1557630662', 'iLabel': 0}, {'lUid': 404639098, 'iRank': 46, 'lScore': 2664004, 'sNickName': 'CC-久伴不离熙', 'sLogoUrl': 'https://huyaimg.msstatic.com/avatar/1018/63/eafbe4e1f05c36776f5807fd9a4c7d_180_135.jpg?1566498428', 'iLabel': 0}, {'lUid': 2450968078, 'iRank': 47, 'lScore': 2452006, 'sNickName': '浮云游子意', 'sLogoUrl': 'https://huyaimg.msstatic.com/avatar/1047/20/00e833cdab17b05f4a7a5ae6b4739a_180_135.jpg?1577120622', 'iLabel': 0}, {'lUid': 2247111749, 'iRank': 48, 'lScore': 2396252, 'sNickName': 'Jeff-尾灯说的对', 'sLogoUrl': 'https://huyaimg.msstatic.com/avatar/1058/55/b6dc6dd1b59cf9226733b61aa9b075_180_135.jpg?1566491457', 'iLabel': 0}, {'lUid': 1661373122, 'iRank': 49, 'lScore': 2198958, 'sNickName': '狂人专属手游商', 'sLogoUrl': 'http://huyaimg.msstatic.com/avatar/1078/5b/0a5de49c6c288b0902fbb2504e87ae_180_135.jpg', 'iLabel': 0}, {'lUid': 1199517251747, 'iRank': 50, 'lScore': 2111111, 'sNickName': '倚楼与天齐', 'sLogoUrl': 'https://huyaimg.msstatic.com/avatar/1044/ef/fd50cae23ff8073c7c2416b57856b9_180_135.jpg?1560270296', 'iLabel': 0}]}},
  },
}